var items = {
  "block.minecraft.acacia_button": "Botón de acacia",
  "block.minecraft.acacia_door": "Puerta de acacia",
  "block.minecraft.acacia_fence": "Cerca de acacia",
  "block.minecraft.acacia_fence_gate": "Puerta de cerca de acacia",
  "block.minecraft.acacia_hanging_sign": "Letrero colgante de acacia",
  "block.minecraft.acacia_leaves": "Hojas de acacia",
  "block.minecraft.acacia_log": "Tronco de acacia",
  "block.minecraft.acacia_planks": "Tablas de acacia",
  "block.minecraft.acacia_pressure_plate": "Placa de presión de acacia",
  "block.minecraft.acacia_sapling": "Retoño de acacia",
  "block.minecraft.acacia_shelf": "Estante de acacia",
  "block.minecraft.acacia_sign": "Letrero de acacia",
  "block.minecraft.acacia_slab": "Losa de acacia",
  "block.minecraft.acacia_stairs": "Escaleras de acacia",
  "block.minecraft.acacia_trapdoor": "Trampilla de acacia",
  "block.minecraft.acacia_wall_hanging_sign": "Letrero colgante de acacia en pared",
  "block.minecraft.acacia_wall_sign": "Letrero de acacia en pared",
  "block.minecraft.acacia_wood": "Leño de acacia",
  "block.minecraft.activator_rail": "Riel activador",
  "block.minecraft.air": "Aire",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bloque de amatista",
  "block.minecraft.amethyst_cluster": "Cúmulo de amatista",
  "block.minecraft.ancient_debris": "Escombros ancestrales",
  "block.minecraft.andesite": "Andesita",
  "block.minecraft.andesite_slab": "Losa de andesita",
  "block.minecraft.andesite_stairs": "Escaleras de andesita",
  "block.minecraft.andesite_wall": "Muro de andesita",
  "block.minecraft.anvil": "Yunque",
  "block.minecraft.attached_melon_stem": "Tallo de sandía unido",
  "block.minecraft.attached_pumpkin_stem": "Tallo de calabaza unido",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Hojas de azalea",
  "block.minecraft.azure_bluet": "Rubiácea",
  "block.minecraft.bamboo": "Bambú",
  "block.minecraft.bamboo_block": "Bloque de bambú",
  "block.minecraft.bamboo_button": "Botón de bambú",
  "block.minecraft.bamboo_door": "Puerta de bambú",
  "block.minecraft.bamboo_fence": "Cerca de bambú",
  "block.minecraft.bamboo_fence_gate": "Puerta de cerca de bambú",
  "block.minecraft.bamboo_hanging_sign": "Letrero colgante de bambú",
  "block.minecraft.bamboo_mosaic": "Mosaico de bambú",
  "block.minecraft.bamboo_mosaic_slab": "Losa de mosaico de bambú",
  "block.minecraft.bamboo_mosaic_stairs": "Escaleras de mosaico de bambú",
  "block.minecraft.bamboo_planks": "Tablas de bambú",
  "block.minecraft.bamboo_pressure_plate": "Placa de presión de bambú",
  "block.minecraft.bamboo_sapling": "Brote de bambú",
  "block.minecraft.bamboo_shelf": "Estante de bambú",
  "block.minecraft.bamboo_sign": "Letrero de bambú",
  "block.minecraft.bamboo_slab": "Losa de bambú",
  "block.minecraft.bamboo_stairs": "Escaleras de bambú",
  "block.minecraft.bamboo_trapdoor": "Trampilla de bambú",
  "block.minecraft.bamboo_wall_hanging_sign": "Letrero colgante de bambú en pared",
  "block.minecraft.bamboo_wall_sign": "Letrero de bambú en pared",
  "block.minecraft.banner.base.black": "Paño completamente negro",
  "block.minecraft.banner.base.blue": "Paño completamente azul",
  "block.minecraft.banner.base.brown": "Paño completamente café",
  "block.minecraft.banner.base.cyan": "Paño completamente turquesa",
  "block.minecraft.banner.base.gray": "Paño completamente gris",
  "block.minecraft.banner.base.green": "Paño completamente verde",
  "block.minecraft.banner.base.light_blue": "Paño completamente celeste",
  "block.minecraft.banner.base.light_gray": "Paño completamente gris claro",
  "block.minecraft.banner.base.lime": "Paño completamente verde lima",
  "block.minecraft.banner.base.magenta": "Paño completamente fucsia",
  "block.minecraft.banner.base.orange": "Paño completamente naranja",
  "block.minecraft.banner.base.pink": "Paño completamente rosado",
  "block.minecraft.banner.base.purple": "Paño completamente morado",
  "block.minecraft.banner.base.red": "Paño completamente rojo",
  "block.minecraft.banner.base.white": "Paño completamente blanco",
  "block.minecraft.banner.base.yellow": "Paño completamente amarillo",
  "block.minecraft.banner.border.black": "Bordura negra",
  "block.minecraft.banner.border.blue": "Bordura azul",
  "block.minecraft.banner.border.brown": "Bordura café",
  "block.minecraft.banner.border.cyan": "Bordura turquesa",
  "block.minecraft.banner.border.gray": "Bordura gris",
  "block.minecraft.banner.border.green": "Bordura verde",
  "block.minecraft.banner.border.light_blue": "Bordura celeste",
  "block.minecraft.banner.border.light_gray": "Bordura gris claro",
  "block.minecraft.banner.border.lime": "Bordura verde lima",
  "block.minecraft.banner.border.magenta": "Bordura fucsia",
  "block.minecraft.banner.border.orange": "Bordura naranja",
  "block.minecraft.banner.border.pink": "Bordura rosada",
  "block.minecraft.banner.border.purple": "Bordura morada",
  "block.minecraft.banner.border.red": "Bordura roja",
  "block.minecraft.banner.border.white": "Bordura blanca",
  "block.minecraft.banner.border.yellow": "Bordura amarilla",
  "block.minecraft.banner.bricks.black": "Mazonado negro",
  "block.minecraft.banner.bricks.blue": "Mazonado azul",
  "block.minecraft.banner.bricks.brown": "Mazonado café",
  "block.minecraft.banner.bricks.cyan": "Mazonado turquesa",
  "block.minecraft.banner.bricks.gray": "Mazonado gris",
  "block.minecraft.banner.bricks.green": "Mazonado verde",
  "block.minecraft.banner.bricks.light_blue": "Mazonado celeste",
  "block.minecraft.banner.bricks.light_gray": "Mazonado gris claro",
  "block.minecraft.banner.bricks.lime": "Mazonado verde lima",
  "block.minecraft.banner.bricks.magenta": "Mazonado fucsia",
  "block.minecraft.banner.bricks.orange": "Mazonado naranja",
  "block.minecraft.banner.bricks.pink": "Mazonado rosado",
  "block.minecraft.banner.bricks.purple": "Mazonado morado",
  "block.minecraft.banner.bricks.red": "Mazonado rojo",
  "block.minecraft.banner.bricks.white": "Mazonado blanco",
  "block.minecraft.banner.bricks.yellow": "Mazonado amarillo",
  "block.minecraft.banner.circle.black": "Roel negro",
  "block.minecraft.banner.circle.blue": "Roel azul",
  "block.minecraft.banner.circle.brown": "Roel café",
  "block.minecraft.banner.circle.cyan": "Roel turquesa",
  "block.minecraft.banner.circle.gray": "Roel gris",
  "block.minecraft.banner.circle.green": "Roel verde",
  "block.minecraft.banner.circle.light_blue": "Roel celeste",
  "block.minecraft.banner.circle.light_gray": "Roel gris claro",
  "block.minecraft.banner.circle.lime": "Roel verde lima",
  "block.minecraft.banner.circle.magenta": "Roel fucsia",
  "block.minecraft.banner.circle.orange": "Roel naranja",
  "block.minecraft.banner.circle.pink": "Roel rosado",
  "block.minecraft.banner.circle.purple": "Roel morado",
  "block.minecraft.banner.circle.red": "Roel rojo",
  "block.minecraft.banner.circle.white": "Roel blanco",
  "block.minecraft.banner.circle.yellow": "Roel amarillo",
  "block.minecraft.banner.creeper.black": "Creeper negro",
  "block.minecraft.banner.creeper.blue": "Creeper azul",
  "block.minecraft.banner.creeper.brown": "Creeper café",
  "block.minecraft.banner.creeper.cyan": "Creeper turquesa",
  "block.minecraft.banner.creeper.gray": "Creeper gris",
  "block.minecraft.banner.creeper.green": "Creeper verde",
  "block.minecraft.banner.creeper.light_blue": "Creeper celeste",
  "block.minecraft.banner.creeper.light_gray": "Creeper gris claro",
  "block.minecraft.banner.creeper.lime": "Creeper verde lima",
  "block.minecraft.banner.creeper.magenta": "Creeper fucsia",
  "block.minecraft.banner.creeper.orange": "Creeper naranja",
  "block.minecraft.banner.creeper.pink": "Creeper rosado",
  "block.minecraft.banner.creeper.purple": "Creeper morado",
  "block.minecraft.banner.creeper.red": "Creeper rojo",
  "block.minecraft.banner.creeper.white": "Creeper blanco",
  "block.minecraft.banner.creeper.yellow": "Creeper amarillo",
  "block.minecraft.banner.cross.black": "Aspa negra",
  "block.minecraft.banner.cross.blue": "Aspa azul",
  "block.minecraft.banner.cross.brown": "Aspa café",
  "block.minecraft.banner.cross.cyan": "Aspa turquesa",
  "block.minecraft.banner.cross.gray": "Aspa gris",
  "block.minecraft.banner.cross.green": "Aspa verde",
  "block.minecraft.banner.cross.light_blue": "Aspa celeste",
  "block.minecraft.banner.cross.light_gray": "Aspa gris claro",
  "block.minecraft.banner.cross.lime": "Aspa verde lima",
  "block.minecraft.banner.cross.magenta": "Aspa fucsia",
  "block.minecraft.banner.cross.orange": "Aspa naranja",
  "block.minecraft.banner.cross.pink": "Aspa rosada",
  "block.minecraft.banner.cross.purple": "Aspa morada",
  "block.minecraft.banner.cross.red": "Aspa roja",
  "block.minecraft.banner.cross.white": "Aspa blanca",
  "block.minecraft.banner.cross.yellow": "Aspa amarilla",
  "block.minecraft.banner.curly_border.black": "Bordura negra dentada",
  "block.minecraft.banner.curly_border.blue": "Bordura azul dentada",
  "block.minecraft.banner.curly_border.brown": "Bordura café dentada",
  "block.minecraft.banner.curly_border.cyan": "Bordura turquesa dentada",
  "block.minecraft.banner.curly_border.gray": "Bordura gris dentada",
  "block.minecraft.banner.curly_border.green": "Bordura verde dentada",
  "block.minecraft.banner.curly_border.light_blue": "Bordura celeste dentada",
  "block.minecraft.banner.curly_border.light_gray": "Bordura gris claro dentada",
  "block.minecraft.banner.curly_border.lime": "Bordura verde lima dentada",
  "block.minecraft.banner.curly_border.magenta": "Bordura fucsia dentada",
  "block.minecraft.banner.curly_border.orange": "Bordura naranja dentada",
  "block.minecraft.banner.curly_border.pink": "Bordura rosada dentada",
  "block.minecraft.banner.curly_border.purple": "Bordura morada dentada",
  "block.minecraft.banner.curly_border.red": "Bordura roja dentada",
  "block.minecraft.banner.curly_border.white": "Bordura blanca dentada",
  "block.minecraft.banner.curly_border.yellow": "Bordura amarilla dentada",
  "block.minecraft.banner.diagonal_left.black": "Tajado negro",
  "block.minecraft.banner.diagonal_left.blue": "Tajado azul",
  "block.minecraft.banner.diagonal_left.brown": "Tajado café",
  "block.minecraft.banner.diagonal_left.cyan": "Tajado turquesa",
  "block.minecraft.banner.diagonal_left.gray": "Tajado gris",
  "block.minecraft.banner.diagonal_left.green": "Tajado verde",
  "block.minecraft.banner.diagonal_left.light_blue": "Tajado celeste",
  "block.minecraft.banner.diagonal_left.light_gray": "Tajado gris claro",
  "block.minecraft.banner.diagonal_left.lime": "Tajado verde lima",
  "block.minecraft.banner.diagonal_left.magenta": "Tajado fucsia",
  "block.minecraft.banner.diagonal_left.orange": "Tajado naranja",
  "block.minecraft.banner.diagonal_left.pink": "Tajado rosado",
  "block.minecraft.banner.diagonal_left.purple": "Tajado morado",
  "block.minecraft.banner.diagonal_left.red": "Tajado rojo",
  "block.minecraft.banner.diagonal_left.white": "Tajado blanco",
  "block.minecraft.banner.diagonal_left.yellow": "Tajado amarillo",
  "block.minecraft.banner.diagonal_right.black": "Tronchado negro",
  "block.minecraft.banner.diagonal_right.blue": "Tronchado azul",
  "block.minecraft.banner.diagonal_right.brown": "Tronchado café",
  "block.minecraft.banner.diagonal_right.cyan": "Tronchado turquesa",
  "block.minecraft.banner.diagonal_right.gray": "Tronchado gris",
  "block.minecraft.banner.diagonal_right.green": "Tronchado verde",
  "block.minecraft.banner.diagonal_right.light_blue": "Tronchado celeste",
  "block.minecraft.banner.diagonal_right.light_gray": "Tronchado gris claro",
  "block.minecraft.banner.diagonal_right.lime": "Tronchado verde lima",
  "block.minecraft.banner.diagonal_right.magenta": "Tronchado fucsia",
  "block.minecraft.banner.diagonal_right.orange": "Tronchado naranja",
  "block.minecraft.banner.diagonal_right.pink": "Tronchado rosado",
  "block.minecraft.banner.diagonal_right.purple": "Tronchado morado",
  "block.minecraft.banner.diagonal_right.red": "Tronchado rojo",
  "block.minecraft.banner.diagonal_right.white": "Tronchado blanco",
  "block.minecraft.banner.diagonal_right.yellow": "Tronchado amarillo",
  "block.minecraft.banner.diagonal_up_left.black": "Tronchado negro invertido",
  "block.minecraft.banner.diagonal_up_left.blue": "Tronchado azul invertido",
  "block.minecraft.banner.diagonal_up_left.brown": "Tronchado café invertido",
  "block.minecraft.banner.diagonal_up_left.cyan": "Tronchado turquesa invertido",
  "block.minecraft.banner.diagonal_up_left.gray": "Tronchado gris invertido",
  "block.minecraft.banner.diagonal_up_left.green": "Tronchado verde invertido",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Tronchado celeste invertido",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Tronchado gris claro invertido",
  "block.minecraft.banner.diagonal_up_left.lime": "Tronchado verde lima invertido",
  "block.minecraft.banner.diagonal_up_left.magenta": "Tronchado fucsia invertido",
  "block.minecraft.banner.diagonal_up_left.orange": "Tronchado naranja invertido",
  "block.minecraft.banner.diagonal_up_left.pink": "Tronchado rosado invertido",
  "block.minecraft.banner.diagonal_up_left.purple": "Tronchado morado invertido",
  "block.minecraft.banner.diagonal_up_left.red": "Tronchado rojo invertido",
  "block.minecraft.banner.diagonal_up_left.white": "Tronchado blanco invertido",
  "block.minecraft.banner.diagonal_up_left.yellow": "Tronchado amarillo invertido",
  "block.minecraft.banner.diagonal_up_right.black": "Tajado negro invertido",
  "block.minecraft.banner.diagonal_up_right.blue": "Tajado azul invertido",
  "block.minecraft.banner.diagonal_up_right.brown": "Tajado café invertido",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tajado turquesa invertido",
  "block.minecraft.banner.diagonal_up_right.gray": "Tajado gris invertido",
  "block.minecraft.banner.diagonal_up_right.green": "Tajado verde invertido",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Tajado celeste invertido",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Tajado gris claro invertido",
  "block.minecraft.banner.diagonal_up_right.lime": "Tajado verde lima invertido",
  "block.minecraft.banner.diagonal_up_right.magenta": "Tajado fucsia invertido",
  "block.minecraft.banner.diagonal_up_right.orange": "Tajado naranja invertido",
  "block.minecraft.banner.diagonal_up_right.pink": "Tajado rosado invertido",
  "block.minecraft.banner.diagonal_up_right.purple": "Tajado morado invertido",
  "block.minecraft.banner.diagonal_up_right.red": "Tajado rojo invertido",
  "block.minecraft.banner.diagonal_up_right.white": "Tajado blanco invertido",
  "block.minecraft.banner.diagonal_up_right.yellow": "Tajado amarillo invertido",
  "block.minecraft.banner.flow.black": "Espiral negro",
  "block.minecraft.banner.flow.blue": "Espiral azul",
  "block.minecraft.banner.flow.brown": "Espiral café",
  "block.minecraft.banner.flow.cyan": "Espiral turquesa",
  "block.minecraft.banner.flow.gray": "Espiral gris",
  "block.minecraft.banner.flow.green": "Espiral verde",
  "block.minecraft.banner.flow.light_blue": "Espiral celeste",
  "block.minecraft.banner.flow.light_gray": "Espiral gris claro",
  "block.minecraft.banner.flow.lime": "Espiral verde lima",
  "block.minecraft.banner.flow.magenta": "Espiral fucsia",
  "block.minecraft.banner.flow.orange": "Espiral naranja",
  "block.minecraft.banner.flow.pink": "Espiral rosado",
  "block.minecraft.banner.flow.purple": "Espiral morado",
  "block.minecraft.banner.flow.red": "Espiral rojo",
  "block.minecraft.banner.flow.white": "Espiral blanco",
  "block.minecraft.banner.flow.yellow": "Espiral amarillo",
  "block.minecraft.banner.flower.black": "Flor negra",
  "block.minecraft.banner.flower.blue": "Flor azul",
  "block.minecraft.banner.flower.brown": "Flor café",
  "block.minecraft.banner.flower.cyan": "Flor turquesa",
  "block.minecraft.banner.flower.gray": "Flor gris",
  "block.minecraft.banner.flower.green": "Flor verde",
  "block.minecraft.banner.flower.light_blue": "Flor celeste",
  "block.minecraft.banner.flower.light_gray": "Flor gris claro",
  "block.minecraft.banner.flower.lime": "Flor verde lima",
  "block.minecraft.banner.flower.magenta": "Flor fucsia",
  "block.minecraft.banner.flower.orange": "Flor naranja",
  "block.minecraft.banner.flower.pink": "Flor rosada",
  "block.minecraft.banner.flower.purple": "Flor morada",
  "block.minecraft.banner.flower.red": "Flor roja",
  "block.minecraft.banner.flower.white": "Flor blanca",
  "block.minecraft.banner.flower.yellow": "Flor amarilla",
  "block.minecraft.banner.globe.black": "Planeta negro",
  "block.minecraft.banner.globe.blue": "Planeta azul",
  "block.minecraft.banner.globe.brown": "Planeta café",
  "block.minecraft.banner.globe.cyan": "Planeta turquesa",
  "block.minecraft.banner.globe.gray": "Planeta gris",
  "block.minecraft.banner.globe.green": "Planeta verde",
  "block.minecraft.banner.globe.light_blue": "Planeta celeste",
  "block.minecraft.banner.globe.light_gray": "Planeta gris claro",
  "block.minecraft.banner.globe.lime": "Planeta verde lima",
  "block.minecraft.banner.globe.magenta": "Planeta fucsia",
  "block.minecraft.banner.globe.orange": "Planeta naranja",
  "block.minecraft.banner.globe.pink": "Planeta rosado",
  "block.minecraft.banner.globe.purple": "Planeta morado",
  "block.minecraft.banner.globe.red": "Planeta rojo",
  "block.minecraft.banner.globe.white": "Planeta blanco",
  "block.minecraft.banner.globe.yellow": "Planeta amarillo",
  "block.minecraft.banner.gradient.black": "Gradiente negro",
  "block.minecraft.banner.gradient.blue": "Gradiente azul",
  "block.minecraft.banner.gradient.brown": "Gradiente café",
  "block.minecraft.banner.gradient.cyan": "Gradiente turquesa",
  "block.minecraft.banner.gradient.gray": "Gradiente gris",
  "block.minecraft.banner.gradient.green": "Gradiente verde",
  "block.minecraft.banner.gradient.light_blue": "Gradiente celeste",
  "block.minecraft.banner.gradient.light_gray": "Gradiente gris claro",
  "block.minecraft.banner.gradient.lime": "Gradiente verde lima",
  "block.minecraft.banner.gradient.magenta": "Gradiente fucsia",
  "block.minecraft.banner.gradient.orange": "Gradiente naranja",
  "block.minecraft.banner.gradient.pink": "Gradiente rosado",
  "block.minecraft.banner.gradient.purple": "Gradiente morado",
  "block.minecraft.banner.gradient.red": "Gradiente rojo",
  "block.minecraft.banner.gradient.white": "Gradiente blanco",
  "block.minecraft.banner.gradient.yellow": "Gradiente amarillo",
  "block.minecraft.banner.gradient_up.black": "Gradiente negro en base",
  "block.minecraft.banner.gradient_up.blue": "Gradiente azul en base",
  "block.minecraft.banner.gradient_up.brown": "Gradiente café en base",
  "block.minecraft.banner.gradient_up.cyan": "Gradiente turquesa en base",
  "block.minecraft.banner.gradient_up.gray": "Gradiente gris en base",
  "block.minecraft.banner.gradient_up.green": "Gradiente verde en base",
  "block.minecraft.banner.gradient_up.light_blue": "Gradiente celeste en base",
  "block.minecraft.banner.gradient_up.light_gray": "Gradiente gris claro en base",
  "block.minecraft.banner.gradient_up.lime": "Gradiente verde lima en base",
  "block.minecraft.banner.gradient_up.magenta": "Gradiente fucsia en base",
  "block.minecraft.banner.gradient_up.orange": "Gradiente naranja en base",
  "block.minecraft.banner.gradient_up.pink": "Gradiente rosado en base",
  "block.minecraft.banner.gradient_up.purple": "Gradiente morado en base",
  "block.minecraft.banner.gradient_up.red": "Gradiente rojo en base",
  "block.minecraft.banner.gradient_up.white": "Gradiente blanco en base",
  "block.minecraft.banner.gradient_up.yellow": "Gradiente amarillo en base",
  "block.minecraft.banner.guster.black": "Torbellino negro",
  "block.minecraft.banner.guster.blue": "Torbellino azul",
  "block.minecraft.banner.guster.brown": "Torbellino café",
  "block.minecraft.banner.guster.cyan": "Torbellino turquesa",
  "block.minecraft.banner.guster.gray": "Torbellino gris",
  "block.minecraft.banner.guster.green": "Torbellino verde",
  "block.minecraft.banner.guster.light_blue": "Torbellino celeste",
  "block.minecraft.banner.guster.light_gray": "Torbellino gris claro",
  "block.minecraft.banner.guster.lime": "Torbellino verde lima",
  "block.minecraft.banner.guster.magenta": "Torbellino fucsia",
  "block.minecraft.banner.guster.orange": "Torbellino naranja",
  "block.minecraft.banner.guster.pink": "Torbellino rosado",
  "block.minecraft.banner.guster.purple": "Torbellino morado",
  "block.minecraft.banner.guster.red": "Torbellino rojo",
  "block.minecraft.banner.guster.white": "Torbellino blanco",
  "block.minecraft.banner.guster.yellow": "Torbellino amarillo",
  "block.minecraft.banner.half_horizontal.black": "Cortado negro",
  "block.minecraft.banner.half_horizontal.blue": "Cortado azul",
  "block.minecraft.banner.half_horizontal.brown": "Cortado café",
  "block.minecraft.banner.half_horizontal.cyan": "Cortado turquesa",
  "block.minecraft.banner.half_horizontal.gray": "Cortado gris",
  "block.minecraft.banner.half_horizontal.green": "Cortado verde",
  "block.minecraft.banner.half_horizontal.light_blue": "Cortado celeste",
  "block.minecraft.banner.half_horizontal.light_gray": "Cortado gris claro",
  "block.minecraft.banner.half_horizontal.lime": "Cortado verde lima",
  "block.minecraft.banner.half_horizontal.magenta": "Cortado fucsia",
  "block.minecraft.banner.half_horizontal.orange": "Cortado naranja",
  "block.minecraft.banner.half_horizontal.pink": "Cortado rosado",
  "block.minecraft.banner.half_horizontal.purple": "Cortado morado",
  "block.minecraft.banner.half_horizontal.red": "Cortado rojo",
  "block.minecraft.banner.half_horizontal.white": "Cortado blanco",
  "block.minecraft.banner.half_horizontal.yellow": "Cortado amarillo",
  "block.minecraft.banner.half_horizontal_bottom.black": "Cortado negro invertido",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Cortado azul invertido",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Cortado café invertido",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cortado turquesa invertido",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Cortado gris invertido",
  "block.minecraft.banner.half_horizontal_bottom.green": "Cortado verde invertido",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Cortado celeste invertido",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Cortado gris claro invertido",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Cortado verde lima invertido",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Cortado fucsia invertido",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Cortado naranja invertido",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Cortado rosado invertido",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Cortado morado invertido",
  "block.minecraft.banner.half_horizontal_bottom.red": "Cortado rojo invertido",
  "block.minecraft.banner.half_horizontal_bottom.white": "Cortado blanco invertido",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Cortado amarillo invertido",
  "block.minecraft.banner.half_vertical.black": "Flanco negro",
  "block.minecraft.banner.half_vertical.blue": "Flanco azul",
  "block.minecraft.banner.half_vertical.brown": "Flanco café",
  "block.minecraft.banner.half_vertical.cyan": "Flanco turquesa",
  "block.minecraft.banner.half_vertical.gray": "Flanco gris",
  "block.minecraft.banner.half_vertical.green": "Flanco verde",
  "block.minecraft.banner.half_vertical.light_blue": "Flanco celeste",
  "block.minecraft.banner.half_vertical.light_gray": "Flanco gris claro",
  "block.minecraft.banner.half_vertical.lime": "Flanco verde lima",
  "block.minecraft.banner.half_vertical.magenta": "Flanco fucsia",
  "block.minecraft.banner.half_vertical.orange": "Flanco naranja",
  "block.minecraft.banner.half_vertical.pink": "Flanco rosado",
  "block.minecraft.banner.half_vertical.purple": "Flanco morado",
  "block.minecraft.banner.half_vertical.red": "Flanco rojo",
  "block.minecraft.banner.half_vertical.white": "Flanco blanco",
  "block.minecraft.banner.half_vertical.yellow": "Flanco amarillo",
  "block.minecraft.banner.half_vertical_right.black": "Flanco negro invertido",
  "block.minecraft.banner.half_vertical_right.blue": "Flanco azul invertido",
  "block.minecraft.banner.half_vertical_right.brown": "Flanco café invertido",
  "block.minecraft.banner.half_vertical_right.cyan": "Flanco turquesa invertido",
  "block.minecraft.banner.half_vertical_right.gray": "Flanco gris invertido",
  "block.minecraft.banner.half_vertical_right.green": "Flanco verde invertido",
  "block.minecraft.banner.half_vertical_right.light_blue": "Flanco celeste invertido",
  "block.minecraft.banner.half_vertical_right.light_gray": "Flanco gris claro invertido",
  "block.minecraft.banner.half_vertical_right.lime": "Flanco verde lima invertido",
  "block.minecraft.banner.half_vertical_right.magenta": "Flanco fucsia invertido",
  "block.minecraft.banner.half_vertical_right.orange": "Flanco naranja a siniestra",
  "block.minecraft.banner.half_vertical_right.pink": "Flanco rosado invertido",
  "block.minecraft.banner.half_vertical_right.purple": "Flanco morado invertido",
  "block.minecraft.banner.half_vertical_right.red": "Flanco rojo invertido",
  "block.minecraft.banner.half_vertical_right.white": "Flanco blanco a siniestra",
  "block.minecraft.banner.half_vertical_right.yellow": "Flanco amarillo invertido",
  "block.minecraft.banner.mojang.black": "Cosa negra",
  "block.minecraft.banner.mojang.blue": "Cosa azul",
  "block.minecraft.banner.mojang.brown": "Cosa café",
  "block.minecraft.banner.mojang.cyan": "Cosa turquesa",
  "block.minecraft.banner.mojang.gray": "Cosa gris",
  "block.minecraft.banner.mojang.green": "Cosa verde",
  "block.minecraft.banner.mojang.light_blue": "Cosa celeste",
  "block.minecraft.banner.mojang.light_gray": "Cosa gris claro",
  "block.minecraft.banner.mojang.lime": "Cosa verde lima",
  "block.minecraft.banner.mojang.magenta": "Cosa fucsia",
  "block.minecraft.banner.mojang.orange": "Cosa naranja",
  "block.minecraft.banner.mojang.pink": "Cosa rosada",
  "block.minecraft.banner.mojang.purple": "Cosa morada",
  "block.minecraft.banner.mojang.red": "Cosa roja",
  "block.minecraft.banner.mojang.white": "Cosa blanca",
  "block.minecraft.banner.mojang.yellow": "Cosa amarilla",
  "block.minecraft.banner.piglin.black": "Hocico negro",
  "block.minecraft.banner.piglin.blue": "Hocico azul",
  "block.minecraft.banner.piglin.brown": "Hocico café",
  "block.minecraft.banner.piglin.cyan": "Hocico turquesa",
  "block.minecraft.banner.piglin.gray": "Hocico gris",
  "block.minecraft.banner.piglin.green": "Hocico verde",
  "block.minecraft.banner.piglin.light_blue": "Hocico celeste",
  "block.minecraft.banner.piglin.light_gray": "Hocico gris claro",
  "block.minecraft.banner.piglin.lime": "Hocico verde lima",
  "block.minecraft.banner.piglin.magenta": "Hocico fucsia",
  "block.minecraft.banner.piglin.orange": "Hocico naranja",
  "block.minecraft.banner.piglin.pink": "Hocico rosado",
  "block.minecraft.banner.piglin.purple": "Hocico morado",
  "block.minecraft.banner.piglin.red": "Hocico rojo",
  "block.minecraft.banner.piglin.white": "Hocico blanco",
  "block.minecraft.banner.piglin.yellow": "Hocico amarillo",
  "block.minecraft.banner.rhombus.black": "Rombo negro",
  "block.minecraft.banner.rhombus.blue": "Rombo azul",
  "block.minecraft.banner.rhombus.brown": "Rombo café",
  "block.minecraft.banner.rhombus.cyan": "Rombo turquesa",
  "block.minecraft.banner.rhombus.gray": "Rombo gris",
  "block.minecraft.banner.rhombus.green": "Rombo verde",
  "block.minecraft.banner.rhombus.light_blue": "Rombo celeste",
  "block.minecraft.banner.rhombus.light_gray": "Rombo gris claro",
  "block.minecraft.banner.rhombus.lime": "Rombo verde lima",
  "block.minecraft.banner.rhombus.magenta": "Rombo fucsia",
  "block.minecraft.banner.rhombus.orange": "Rombo naranja",
  "block.minecraft.banner.rhombus.pink": "Rombo rosado",
  "block.minecraft.banner.rhombus.purple": "Rombo morado",
  "block.minecraft.banner.rhombus.red": "Rombo rojo",
  "block.minecraft.banner.rhombus.white": "Rombo blanco",
  "block.minecraft.banner.rhombus.yellow": "Rombo amarillo",
  "block.minecraft.banner.skull.black": "Calavera negra",
  "block.minecraft.banner.skull.blue": "Calavera azul",
  "block.minecraft.banner.skull.brown": "Calavera café",
  "block.minecraft.banner.skull.cyan": "Calavera turquesa",
  "block.minecraft.banner.skull.gray": "Calavera gris",
  "block.minecraft.banner.skull.green": "Calavera verde",
  "block.minecraft.banner.skull.light_blue": "Calavera celeste",
  "block.minecraft.banner.skull.light_gray": "Calavera gris",
  "block.minecraft.banner.skull.lime": "Calavera verde lima",
  "block.minecraft.banner.skull.magenta": "Calavera fucsia",
  "block.minecraft.banner.skull.orange": "Calavera naranja",
  "block.minecraft.banner.skull.pink": "Calavera rosada",
  "block.minecraft.banner.skull.purple": "Calavera morada",
  "block.minecraft.banner.skull.red": "Calavera roja",
  "block.minecraft.banner.skull.white": "Calavera blanca",
  "block.minecraft.banner.skull.yellow": "Calavera amarilla",
  "block.minecraft.banner.small_stripes.black": "Bastonado negro",
  "block.minecraft.banner.small_stripes.blue": "Bastonado azul",
  "block.minecraft.banner.small_stripes.brown": "Bastonado café",
  "block.minecraft.banner.small_stripes.cyan": "Bastonado turquesa",
  "block.minecraft.banner.small_stripes.gray": "Bastonado gris",
  "block.minecraft.banner.small_stripes.green": "Bastonado verde",
  "block.minecraft.banner.small_stripes.light_blue": "Bastonado celeste",
  "block.minecraft.banner.small_stripes.light_gray": "Bastonado gris claro",
  "block.minecraft.banner.small_stripes.lime": "Bastonado verde lima",
  "block.minecraft.banner.small_stripes.magenta": "Bastonado fucsia",
  "block.minecraft.banner.small_stripes.orange": "Bastonado naranja",
  "block.minecraft.banner.small_stripes.pink": "Bastonado rosado",
  "block.minecraft.banner.small_stripes.purple": "Bastonado morado",
  "block.minecraft.banner.small_stripes.red": "Bastonado rojo",
  "block.minecraft.banner.small_stripes.white": "Bastonado blanco",
  "block.minecraft.banner.small_stripes.yellow": "Bastonado amarillo",
  "block.minecraft.banner.square_bottom_left.black": "Cantón negro en base a diestra",
  "block.minecraft.banner.square_bottom_left.blue": "Cantón azul en base a diestra",
  "block.minecraft.banner.square_bottom_left.brown": "Cantón café en base a diestra",
  "block.minecraft.banner.square_bottom_left.cyan": "Cantón turquesa en base a diestra",
  "block.minecraft.banner.square_bottom_left.gray": "Cantón gris en base a diestra",
  "block.minecraft.banner.square_bottom_left.green": "Cantón verde en base a diestra",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cantón celeste en base a diestra",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cantón gris claro en base a diestra",
  "block.minecraft.banner.square_bottom_left.lime": "Cantón verde lima en base a diestra",
  "block.minecraft.banner.square_bottom_left.magenta": "Cantón fucsia en base a diestra",
  "block.minecraft.banner.square_bottom_left.orange": "Cantón naranja en base a diestra",
  "block.minecraft.banner.square_bottom_left.pink": "Cantón rosado en base a diestra",
  "block.minecraft.banner.square_bottom_left.purple": "Cantón morado en base a diestra",
  "block.minecraft.banner.square_bottom_left.red": "Cantón rojo en base a diestra",
  "block.minecraft.banner.square_bottom_left.white": "Cantón blanco en base a diestra",
  "block.minecraft.banner.square_bottom_left.yellow": "Cantón amarillo en base a diestra",
  "block.minecraft.banner.square_bottom_right.black": "Cantón negro en base a siniestra",
  "block.minecraft.banner.square_bottom_right.blue": "Cantón azul en base a siniestra",
  "block.minecraft.banner.square_bottom_right.brown": "Cantón café en base a siniestra",
  "block.minecraft.banner.square_bottom_right.cyan": "Cantón turquesa en base a siniestra",
  "block.minecraft.banner.square_bottom_right.gray": "Cantón gris en base a siniestra",
  "block.minecraft.banner.square_bottom_right.green": "Cantón verde en base a siniestra",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cantón celeste en base a siniestra",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cantón gris claro en base a siniestra",
  "block.minecraft.banner.square_bottom_right.lime": "Cantón verde lima en base a siniestra",
  "block.minecraft.banner.square_bottom_right.magenta": "Cantón fucsia en base a siniestra",
  "block.minecraft.banner.square_bottom_right.orange": "Cantón naranja en base a siniestra",
  "block.minecraft.banner.square_bottom_right.pink": "Cantón rosado en base a siniestra",
  "block.minecraft.banner.square_bottom_right.purple": "Cantón morado en base a siniestra",
  "block.minecraft.banner.square_bottom_right.red": "Cantón rojo en base a siniestra",
  "block.minecraft.banner.square_bottom_right.white": "Cantón blanco en base a siniestra",
  "block.minecraft.banner.square_bottom_right.yellow": "Cantón amarillo en base a siniestra",
  "block.minecraft.banner.square_top_left.black": "Cantón negro en jefe a diestra",
  "block.minecraft.banner.square_top_left.blue": "Cantón azul en jefe a diestra",
  "block.minecraft.banner.square_top_left.brown": "Cantón café en jefe a diestra",
  "block.minecraft.banner.square_top_left.cyan": "Cantón diestro turquesa en jefe",
  "block.minecraft.banner.square_top_left.gray": "Cantón gris en jefe a diestra",
  "block.minecraft.banner.square_top_left.green": "Cantón verde en jefe a diestra",
  "block.minecraft.banner.square_top_left.light_blue": "Cantón celeste en jefe a diestra",
  "block.minecraft.banner.square_top_left.light_gray": "Cantón gris claro en jefe a diestra",
  "block.minecraft.banner.square_top_left.lime": "Cantón verde lima en jefe a diestra",
  "block.minecraft.banner.square_top_left.magenta": "Cantón fucsia en jefe a diestra",
  "block.minecraft.banner.square_top_left.orange": "Cantón naranja en jefe a diestra",
  "block.minecraft.banner.square_top_left.pink": "Cantón rosado en jefe a diestra",
  "block.minecraft.banner.square_top_left.purple": "Cantón morado en jefe a diestra",
  "block.minecraft.banner.square_top_left.red": "Cantón rojo en jefe a diestra",
  "block.minecraft.banner.square_top_left.white": "Cantón blanco en jefe a diestra",
  "block.minecraft.banner.square_top_left.yellow": "Cantón amarillo en jefe a diestra",
  "block.minecraft.banner.square_top_right.black": "Cantón negro en jefe a siniestra",
  "block.minecraft.banner.square_top_right.blue": "Cantón azul en jefe a siniestra",
  "block.minecraft.banner.square_top_right.brown": "Cantón café en jefe a siniestra",
  "block.minecraft.banner.square_top_right.cyan": "Cantón siniestro turquesa en jefe",
  "block.minecraft.banner.square_top_right.gray": "Cantón gris en jefe a siniestra",
  "block.minecraft.banner.square_top_right.green": "Cantón verde en jefe a siniestra",
  "block.minecraft.banner.square_top_right.light_blue": "Cantón celeste en jefe a siniestra",
  "block.minecraft.banner.square_top_right.light_gray": "Cantón gris claro en jefe a siniestra",
  "block.minecraft.banner.square_top_right.lime": "Cantón verde lima en jefe a siniestra",
  "block.minecraft.banner.square_top_right.magenta": "Cantón fucsia en jefe a siniestra",
  "block.minecraft.banner.square_top_right.orange": "Cantón naranja en jefe a siniestra",
  "block.minecraft.banner.square_top_right.pink": "Cantón rosado en jefe a siniestra",
  "block.minecraft.banner.square_top_right.purple": "Cantón morado en jefe a siniestra",
  "block.minecraft.banner.square_top_right.red": "Cantón rojo en jefe a siniestra",
  "block.minecraft.banner.square_top_right.white": "Cantón blanco en jefe a siniestra",
  "block.minecraft.banner.square_top_right.yellow": "Cantón amarillo en jefe a siniestra",
  "block.minecraft.banner.straight_cross.black": "Cruz negra",
  "block.minecraft.banner.straight_cross.blue": "Cruz azul",
  "block.minecraft.banner.straight_cross.brown": "Cruz café",
  "block.minecraft.banner.straight_cross.cyan": "Cruz turquesa",
  "block.minecraft.banner.straight_cross.gray": "Cruz gris",
  "block.minecraft.banner.straight_cross.green": "Cruz verde",
  "block.minecraft.banner.straight_cross.light_blue": "Cruz celeste",
  "block.minecraft.banner.straight_cross.light_gray": "Cruz gris claro",
  "block.minecraft.banner.straight_cross.lime": "Cruz verde lima",
  "block.minecraft.banner.straight_cross.magenta": "Cruz fucsia",
  "block.minecraft.banner.straight_cross.orange": "Cruz naranja",
  "block.minecraft.banner.straight_cross.pink": "Cruz rosada",
  "block.minecraft.banner.straight_cross.purple": "Cruz morada",
  "block.minecraft.banner.straight_cross.red": "Cruz roja",
  "block.minecraft.banner.straight_cross.white": "Cruz blanca",
  "block.minecraft.banner.straight_cross.yellow": "Cruz amarilla",
  "block.minecraft.banner.stripe_bottom.black": "Base negra",
  "block.minecraft.banner.stripe_bottom.blue": "Base azul",
  "block.minecraft.banner.stripe_bottom.brown": "Base café",
  "block.minecraft.banner.stripe_bottom.cyan": "Base turquesa",
  "block.minecraft.banner.stripe_bottom.gray": "Base gris",
  "block.minecraft.banner.stripe_bottom.green": "Base verde",
  "block.minecraft.banner.stripe_bottom.light_blue": "Base celeste",
  "block.minecraft.banner.stripe_bottom.light_gray": "Base gris claro",
  "block.minecraft.banner.stripe_bottom.lime": "Base verde lima",
  "block.minecraft.banner.stripe_bottom.magenta": "Base fucsia",
  "block.minecraft.banner.stripe_bottom.orange": "Base naranja",
  "block.minecraft.banner.stripe_bottom.pink": "Base rosada",
  "block.minecraft.banner.stripe_bottom.purple": "Base morada",
  "block.minecraft.banner.stripe_bottom.red": "Base roja",
  "block.minecraft.banner.stripe_bottom.white": "Base blanca",
  "block.minecraft.banner.stripe_bottom.yellow": "Base amarilla",
  "block.minecraft.banner.stripe_center.black": "Palo negro",
  "block.minecraft.banner.stripe_center.blue": "Palo azul",
  "block.minecraft.banner.stripe_center.brown": "Palo café",
  "block.minecraft.banner.stripe_center.cyan": "Palo turquesa",
  "block.minecraft.banner.stripe_center.gray": "Palo gris",
  "block.minecraft.banner.stripe_center.green": "Palo verde",
  "block.minecraft.banner.stripe_center.light_blue": "Palo celeste",
  "block.minecraft.banner.stripe_center.light_gray": "Palo gris claro",
  "block.minecraft.banner.stripe_center.lime": "Palo verde lima",
  "block.minecraft.banner.stripe_center.magenta": "Palo fucsia",
  "block.minecraft.banner.stripe_center.orange": "Palo naranja",
  "block.minecraft.banner.stripe_center.pink": "Palo rosado",
  "block.minecraft.banner.stripe_center.purple": "Palo morado",
  "block.minecraft.banner.stripe_center.red": "Palo rojo",
  "block.minecraft.banner.stripe_center.white": "Palo blanco",
  "block.minecraft.banner.stripe_center.yellow": "Palo amarillo",
  "block.minecraft.banner.stripe_downleft.black": "Banda negra a siniestra",
  "block.minecraft.banner.stripe_downleft.blue": "Banda azul a siniestra",
  "block.minecraft.banner.stripe_downleft.brown": "Banda café a siniestra",
  "block.minecraft.banner.stripe_downleft.cyan": "Banda turquesa a siniestra",
  "block.minecraft.banner.stripe_downleft.gray": "Banda gris a siniestra",
  "block.minecraft.banner.stripe_downleft.green": "Banda verde a siniestra",
  "block.minecraft.banner.stripe_downleft.light_blue": "Banda celeste a siniestra",
  "block.minecraft.banner.stripe_downleft.light_gray": "Banda gris claro a siniestra",
  "block.minecraft.banner.stripe_downleft.lime": "Banda verde lima a siniestra",
  "block.minecraft.banner.stripe_downleft.magenta": "Banda fucsia a siniestra",
  "block.minecraft.banner.stripe_downleft.orange": "Banda naranja a siniestra",
  "block.minecraft.banner.stripe_downleft.pink": "Banda rosada a siniestra",
  "block.minecraft.banner.stripe_downleft.purple": "Banda morada a siniestra",
  "block.minecraft.banner.stripe_downleft.red": "Banda roja a siniestra",
  "block.minecraft.banner.stripe_downleft.white": "Banda blanca a siniestra",
  "block.minecraft.banner.stripe_downleft.yellow": "Banda amarilla a siniestra",
  "block.minecraft.banner.stripe_downright.black": "Banda negra",
  "block.minecraft.banner.stripe_downright.blue": "Banda azul",
  "block.minecraft.banner.stripe_downright.brown": "Banda café",
  "block.minecraft.banner.stripe_downright.cyan": "Banda turquesa",
  "block.minecraft.banner.stripe_downright.gray": "Banda gris",
  "block.minecraft.banner.stripe_downright.green": "Banda verde",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda celeste",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda gris claro",
  "block.minecraft.banner.stripe_downright.lime": "Banda verde lima",
  "block.minecraft.banner.stripe_downright.magenta": "Banda fucsia",
  "block.minecraft.banner.stripe_downright.orange": "Banda naranja",
  "block.minecraft.banner.stripe_downright.pink": "Banda rosada",
  "block.minecraft.banner.stripe_downright.purple": "Banda morada",
  "block.minecraft.banner.stripe_downright.red": "Banda roja",
  "block.minecraft.banner.stripe_downright.white": "Banda blanca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda amarilla",
  "block.minecraft.banner.stripe_left.black": "Palo negro a diestra",
  "block.minecraft.banner.stripe_left.blue": "Palo azul a diestra",
  "block.minecraft.banner.stripe_left.brown": "Palo café a diestra",
  "block.minecraft.banner.stripe_left.cyan": "Palo turquesa a diestra",
  "block.minecraft.banner.stripe_left.gray": "Palo gris a diestra",
  "block.minecraft.banner.stripe_left.green": "Palo verde a diestra",
  "block.minecraft.banner.stripe_left.light_blue": "Palo celeste a diestra",
  "block.minecraft.banner.stripe_left.light_gray": "Palo gris claro a diestra",
  "block.minecraft.banner.stripe_left.lime": "Palo verde lima a diestra",
  "block.minecraft.banner.stripe_left.magenta": "Palo fucsia a diestra",
  "block.minecraft.banner.stripe_left.orange": "Palo naranja a diestra",
  "block.minecraft.banner.stripe_left.pink": "Palo rosado a diestra",
  "block.minecraft.banner.stripe_left.purple": "Palo morado a diestra",
  "block.minecraft.banner.stripe_left.red": "Palo rojo a diestra",
  "block.minecraft.banner.stripe_left.white": "Palo blanco a diestra",
  "block.minecraft.banner.stripe_left.yellow": "Palo amarillo a diestra",
  "block.minecraft.banner.stripe_middle.black": "Franja negra",
  "block.minecraft.banner.stripe_middle.blue": "Franja azul",
  "block.minecraft.banner.stripe_middle.brown": "Franja café",
  "block.minecraft.banner.stripe_middle.cyan": "Franja turquesa",
  "block.minecraft.banner.stripe_middle.gray": "Franja gris",
  "block.minecraft.banner.stripe_middle.green": "Franja verde",
  "block.minecraft.banner.stripe_middle.light_blue": "Franja celeste",
  "block.minecraft.banner.stripe_middle.light_gray": "Franja gris claro",
  "block.minecraft.banner.stripe_middle.lime": "Franja verde lima",
  "block.minecraft.banner.stripe_middle.magenta": "Franja fucsia",
  "block.minecraft.banner.stripe_middle.orange": "Franja naranja",
  "block.minecraft.banner.stripe_middle.pink": "Franja rosada",
  "block.minecraft.banner.stripe_middle.purple": "Franja morada",
  "block.minecraft.banner.stripe_middle.red": "Franja roja",
  "block.minecraft.banner.stripe_middle.white": "Franja blanca",
  "block.minecraft.banner.stripe_middle.yellow": "Franja amarilla",
  "block.minecraft.banner.stripe_right.black": "Palo negro a siniestra",
  "block.minecraft.banner.stripe_right.blue": "Palo azul a siniestra",
  "block.minecraft.banner.stripe_right.brown": "Palo café a siniestra",
  "block.minecraft.banner.stripe_right.cyan": "Palo turquesa a siniestra",
  "block.minecraft.banner.stripe_right.gray": "Palo gris a siniestra",
  "block.minecraft.banner.stripe_right.green": "Palo verde a siniestra",
  "block.minecraft.banner.stripe_right.light_blue": "Palo celeste a siniestra",
  "block.minecraft.banner.stripe_right.light_gray": "Palo gris claro a siniestra",
  "block.minecraft.banner.stripe_right.lime": "Palo verde lima a siniestra",
  "block.minecraft.banner.stripe_right.magenta": "Palo fucsia a siniestra",
  "block.minecraft.banner.stripe_right.orange": "Palo naranja a siniestra",
  "block.minecraft.banner.stripe_right.pink": "Palo rosado a siniestra",
  "block.minecraft.banner.stripe_right.purple": "Palo morado a siniestra",
  "block.minecraft.banner.stripe_right.red": "Palo rojo a siniestra",
  "block.minecraft.banner.stripe_right.white": "Palo blanco a siniestra",
  "block.minecraft.banner.stripe_right.yellow": "Palo amarillo a siniestra",
  "block.minecraft.banner.stripe_top.black": "Jefe negro",
  "block.minecraft.banner.stripe_top.blue": "Jefe azul",
  "block.minecraft.banner.stripe_top.brown": "Jefe café",
  "block.minecraft.banner.stripe_top.cyan": "Jefe turquesa",
  "block.minecraft.banner.stripe_top.gray": "Jefe gris",
  "block.minecraft.banner.stripe_top.green": "Jefe verde",
  "block.minecraft.banner.stripe_top.light_blue": "Jefe celeste",
  "block.minecraft.banner.stripe_top.light_gray": "Jefe gris claro",
  "block.minecraft.banner.stripe_top.lime": "Jefe verde lima",
  "block.minecraft.banner.stripe_top.magenta": "Jefe fucsia",
  "block.minecraft.banner.stripe_top.orange": "Jefe naranja",
  "block.minecraft.banner.stripe_top.pink": "Jefe rosado",
  "block.minecraft.banner.stripe_top.purple": "Jefe morado",
  "block.minecraft.banner.stripe_top.red": "Jefe rojo",
  "block.minecraft.banner.stripe_top.white": "Jefe blanco",
  "block.minecraft.banner.stripe_top.yellow": "Jefe amarillo",
  "block.minecraft.banner.triangle_bottom.black": "Chevrón negro",
  "block.minecraft.banner.triangle_bottom.blue": "Chevrón azul",
  "block.minecraft.banner.triangle_bottom.brown": "Chevrón café",
  "block.minecraft.banner.triangle_bottom.cyan": "Chevrón turquesa",
  "block.minecraft.banner.triangle_bottom.gray": "Chevrón gris",
  "block.minecraft.banner.triangle_bottom.green": "Chevrón verde",
  "block.minecraft.banner.triangle_bottom.light_blue": "Chevrón celeste",
  "block.minecraft.banner.triangle_bottom.light_gray": "Chevrón celeste",
  "block.minecraft.banner.triangle_bottom.lime": "Chevrón verde lima",
  "block.minecraft.banner.triangle_bottom.magenta": "Chevrón fucsia",
  "block.minecraft.banner.triangle_bottom.orange": "Chevrón naranja",
  "block.minecraft.banner.triangle_bottom.pink": "Chevrón rosado",
  "block.minecraft.banner.triangle_bottom.purple": "Chevrón morado",
  "block.minecraft.banner.triangle_bottom.red": "Chevrón Rojo",
  "block.minecraft.banner.triangle_bottom.white": "Chevrón blanco",
  "block.minecraft.banner.triangle_bottom.yellow": "Chevrón amarillo",
  "block.minecraft.banner.triangle_top.black": "Chevrón negro invertido",
  "block.minecraft.banner.triangle_top.blue": "Chevrón azul invertido",
  "block.minecraft.banner.triangle_top.brown": "Chevrón café invertido",
  "block.minecraft.banner.triangle_top.cyan": "Chevrón turquesa invertido",
  "block.minecraft.banner.triangle_top.gray": "Chevrón gris invertido",
  "block.minecraft.banner.triangle_top.green": "Chevrón verde invertido",
  "block.minecraft.banner.triangle_top.light_blue": "Chevrón celeste invertido",
  "block.minecraft.banner.triangle_top.light_gray": "Chevrón gris claro invertido",
  "block.minecraft.banner.triangle_top.lime": "Chevrón verde lima invertido",
  "block.minecraft.banner.triangle_top.magenta": "Chevrón fucsia invertido",
  "block.minecraft.banner.triangle_top.orange": "Chevrón naranja invertido",
  "block.minecraft.banner.triangle_top.pink": "Chevrón rosado invertido",
  "block.minecraft.banner.triangle_top.purple": "Chevrón morado invertido",
  "block.minecraft.banner.triangle_top.red": "Chevrón rojo invertido",
  "block.minecraft.banner.triangle_top.white": "Chevrón blanco invertido",
  "block.minecraft.banner.triangle_top.yellow": "Chevrón amarillo invertido",
  "block.minecraft.banner.triangles_bottom.black": "Base negra dentada",
  "block.minecraft.banner.triangles_bottom.blue": "Base azul dentada",
  "block.minecraft.banner.triangles_bottom.brown": "Base café dentada",
  "block.minecraft.banner.triangles_bottom.cyan": "Base turquesa dentada",
  "block.minecraft.banner.triangles_bottom.gray": "Base gris dentada",
  "block.minecraft.banner.triangles_bottom.green": "Base verde dentada",
  "block.minecraft.banner.triangles_bottom.light_blue": "Base celeste dentada",
  "block.minecraft.banner.triangles_bottom.light_gray": "Base gris claro dentada",
  "block.minecraft.banner.triangles_bottom.lime": "Base verde lima dentada",
  "block.minecraft.banner.triangles_bottom.magenta": "Base fucsia dentada",
  "block.minecraft.banner.triangles_bottom.orange": "Base naranja dentada",
  "block.minecraft.banner.triangles_bottom.pink": "Base rosada dentada",
  "block.minecraft.banner.triangles_bottom.purple": "Base morada dentada",
  "block.minecraft.banner.triangles_bottom.red": "Base roja dentada",
  "block.minecraft.banner.triangles_bottom.white": "Base blanca dentada",
  "block.minecraft.banner.triangles_bottom.yellow": "Base amarilla dentada",
  "block.minecraft.banner.triangles_top.black": "Jefe negro dentado",
  "block.minecraft.banner.triangles_top.blue": "Jefe azul dentado",
  "block.minecraft.banner.triangles_top.brown": "Jefe café dentado",
  "block.minecraft.banner.triangles_top.cyan": "Jefe turquesa dentado",
  "block.minecraft.banner.triangles_top.gray": "Jefe gris dentado",
  "block.minecraft.banner.triangles_top.green": "Jefe verde dentado",
  "block.minecraft.banner.triangles_top.light_blue": "Jefe celeste dentado",
  "block.minecraft.banner.triangles_top.light_gray": "Jefe gris claro dentado",
  "block.minecraft.banner.triangles_top.lime": "Jefe verde lima dentado",
  "block.minecraft.banner.triangles_top.magenta": "Jefe fucsia dentado",
  "block.minecraft.banner.triangles_top.orange": "Jefe naranja dentado",
  "block.minecraft.banner.triangles_top.pink": "Jefe rosado dentado",
  "block.minecraft.banner.triangles_top.purple": "Jefe morado dentado",
  "block.minecraft.banner.triangles_top.red": "Jefe rojo dentado",
  "block.minecraft.banner.triangles_top.white": "Jefe blanco dentado",
  "block.minecraft.banner.triangles_top.yellow": "Jefe amarillo dentado",
  "block.minecraft.barrel": "Barril",
  "block.minecraft.barrier": "Barrera",
  "block.minecraft.basalt": "Basalto",
  "block.minecraft.beacon": "Faro",
  "block.minecraft.beacon.primary": "Poder primario",
  "block.minecraft.beacon.secondary": "Poder secundario",
  "block.minecraft.bed.no_sleep": "Solo puedes dormir por la noche o durante tormentas eléctricas",
  "block.minecraft.bed.not_safe": "No puedes dormir ahora; hay monstruos cerca",
  "block.minecraft.bed.obstructed": "La cama está obstruida",
  "block.minecraft.bed.occupied": "La cama está ocupada",
  "block.minecraft.bed.too_far_away": "No puedes dormir ahora; la cama está muy lejos",
  "block.minecraft.bedrock": "Piedra base",
  "block.minecraft.bee_nest": "Colmena",
  "block.minecraft.beehive": "Apiario",
  "block.minecraft.beetroots": "Remolachas",
  "block.minecraft.bell": "Campana",
  "block.minecraft.big_dripleaf": "Plantaforma grande",
  "block.minecraft.big_dripleaf_stem": "Tallo de plantaforma grande",
  "block.minecraft.birch_button": "Botón de abedul",
  "block.minecraft.birch_door": "Puerta de abedul",
  "block.minecraft.birch_fence": "Cerca de abedul",
  "block.minecraft.birch_fence_gate": "Puerta de cerca de abedul",
  "block.minecraft.birch_hanging_sign": "Letrero colgante de abedul",
  "block.minecraft.birch_leaves": "Hojas de abedul",
  "block.minecraft.birch_log": "Tronco de abedul",
  "block.minecraft.birch_planks": "Tablas de abedul",
  "block.minecraft.birch_pressure_plate": "Placa de presión de abedul",
  "block.minecraft.birch_sapling": "Retoño de abedul",
  "block.minecraft.birch_shelf": "Estante de abedul",
  "block.minecraft.birch_sign": "Letrero de abedul",
  "block.minecraft.birch_slab": "Losa de abedul",
  "block.minecraft.birch_stairs": "Escaleras de abedul",
  "block.minecraft.birch_trapdoor": "Trampilla de abedul",
  "block.minecraft.birch_wall_hanging_sign": "Letrero colgante de abedul en pared",
  "block.minecraft.birch_wall_sign": "Letrero de abedul en pared",
  "block.minecraft.birch_wood": "Leño de abedul",
  "block.minecraft.black_banner": "Estandarte negro",
  "block.minecraft.black_bed": "Cama negra",
  "block.minecraft.black_candle": "Vela negra",
  "block.minecraft.black_candle_cake": "Pastel con vela negra",
  "block.minecraft.black_carpet": "Alfombra negra",
  "block.minecraft.black_concrete": "Concreto negro",
  "block.minecraft.black_concrete_powder": "Cemento negro",
  "block.minecraft.black_glazed_terracotta": "Azulejo negro",
  "block.minecraft.black_shulker_box": "Caja de shulker negra",
  "block.minecraft.black_stained_glass": "Vidrio negro",
  "block.minecraft.black_stained_glass_pane": "Panel de vidrio negro",
  "block.minecraft.black_terracotta": "Terracota negra",
  "block.minecraft.black_wool": "Lana negra",
  "block.minecraft.blackstone": "Piedra negra",
  "block.minecraft.blackstone_slab": "Losa de piedra negra",
  "block.minecraft.blackstone_stairs": "Escaleras de piedra negra",
  "block.minecraft.blackstone_wall": "Muro de piedra negra",
  "block.minecraft.blast_furnace": "Alto horno",
  "block.minecraft.blue_banner": "Estandarte azul",
  "block.minecraft.blue_bed": "Cama azul",
  "block.minecraft.blue_candle": "Vela azul",
  "block.minecraft.blue_candle_cake": "Pastel con vela azul",
  "block.minecraft.blue_carpet": "Alfombra azul",
  "block.minecraft.blue_concrete": "Concreto azul",
  "block.minecraft.blue_concrete_powder": "Cemento azul",
  "block.minecraft.blue_glazed_terracotta": "Azulejo azul",
  "block.minecraft.blue_ice": "Hielo azul",
  "block.minecraft.blue_orchid": "Orquídea azul",
  "block.minecraft.blue_shulker_box": "Caja de shulker azul",
  "block.minecraft.blue_stained_glass": "Vidrio azul",
  "block.minecraft.blue_stained_glass_pane": "Panel de vidrio azul",
  "block.minecraft.blue_terracotta": "Terracota azul",
  "block.minecraft.blue_wool": "Lana azul",
  "block.minecraft.bone_block": "Bloque de huesos",
  "block.minecraft.bookshelf": "Librero",
  "block.minecraft.brain_coral": "Coral de cerebro",
  "block.minecraft.brain_coral_block": "Bloque de coral de cerebro",
  "block.minecraft.brain_coral_fan": "Gorgonia de cerebro",
  "block.minecraft.brain_coral_wall_fan": "Gorgonia de cerebro en pared",
  "block.minecraft.brewing_stand": "Soporte para pociones",
  "block.minecraft.brick_slab": "Losa de ladrillos",
  "block.minecraft.brick_stairs": "Escaleras de ladrillos",
  "block.minecraft.brick_wall": "Muro de ladrillos",
  "block.minecraft.bricks": "Ladrillos",
  "block.minecraft.brown_banner": "Estandarte café",
  "block.minecraft.brown_bed": "Cama café",
  "block.minecraft.brown_candle": "Vela café",
  "block.minecraft.brown_candle_cake": "Pastel con vela café",
  "block.minecraft.brown_carpet": "Alfombra café",
  "block.minecraft.brown_concrete": "Concreto café",
  "block.minecraft.brown_concrete_powder": "Cemento café",
  "block.minecraft.brown_glazed_terracotta": "Azulejo café",
  "block.minecraft.brown_mushroom": "Champiñón café",
  "block.minecraft.brown_mushroom_block": "Bloque de champiñón café",
  "block.minecraft.brown_shulker_box": "Caja de shulker café",
  "block.minecraft.brown_stained_glass": "Vidrio café",
  "block.minecraft.brown_stained_glass_pane": "Panel de vidrio café",
  "block.minecraft.brown_terracotta": "Terracota café",
  "block.minecraft.brown_wool": "Lana café",
  "block.minecraft.bubble_column": "Columna de burbujas",
  "block.minecraft.bubble_coral": "Coral de burbuja",
  "block.minecraft.bubble_coral_block": "Bloque de coral de burbuja",
  "block.minecraft.bubble_coral_fan": "Gorgonia de burbuja",
  "block.minecraft.bubble_coral_wall_fan": "Gorgonia de burbuja en pared",
  "block.minecraft.budding_amethyst": "Brote de amatista",
  "block.minecraft.bush": "Arbusto",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Flor de cactus",
  "block.minecraft.cake": "Pastel",
  "block.minecraft.calcite": "Calcita",
  "block.minecraft.calibrated_sculk_sensor": "Sensor de sculk calibrado",
  "block.minecraft.campfire": "Fogata",
  "block.minecraft.candle": "Vela",
  "block.minecraft.candle_cake": "Vela de pastel",
  "block.minecraft.carrots": "Zanahorias",
  "block.minecraft.cartography_table": "Mesa de cartografía",
  "block.minecraft.carved_pumpkin": "Calabaza tallada",
  "block.minecraft.cauldron": "Caldero",
  "block.minecraft.cave_air": "Aire de cueva",
  "block.minecraft.cave_vines": "Lianas de cueva",
  "block.minecraft.cave_vines_plant": "Planta de lianas de cueva",
  "block.minecraft.chain": "Cadena",
  "block.minecraft.chain_command_block": "Bloque de comandos de cadena",
  "block.minecraft.cherry_button": "Botón de cerezo",
  "block.minecraft.cherry_door": "Puerta de cerezo",
  "block.minecraft.cherry_fence": "Cerca de cerezo",
  "block.minecraft.cherry_fence_gate": "Puerta de cerca de cerezo",
  "block.minecraft.cherry_hanging_sign": "Cartel colgante de cerezo",
  "block.minecraft.cherry_leaves": "Hojas de cerezo",
  "block.minecraft.cherry_log": "Tronco de cerezo",
  "block.minecraft.cherry_planks": "Tablas de cerezo",
  "block.minecraft.cherry_pressure_plate": "Placa de presión de cerezo",
  "block.minecraft.cherry_sapling": "Retoño de cerezo",
  "block.minecraft.cherry_shelf": "Estante de cerezo",
  "block.minecraft.cherry_sign": "Letrero de cerezo",
  "block.minecraft.cherry_slab": "Losa de cerezo",
  "block.minecraft.cherry_stairs": "Escaleras de cerezo",
  "block.minecraft.cherry_trapdoor": "Trampilla de cerezo",
  "block.minecraft.cherry_wall_hanging_sign": "Letrero colgante de cerezo en pared",
  "block.minecraft.cherry_wall_sign": "Letrero de cerezo en pared",
  "block.minecraft.cherry_wood": "Leño de cerezo",
  "block.minecraft.chest": "Cofre",
  "block.minecraft.chipped_anvil": "Yunque dañado",
  "block.minecraft.chiseled_bookshelf": "Librero tallado",
  "block.minecraft.chiseled_copper": "Cobre cincelado",
  "block.minecraft.chiseled_deepslate": "Piedra profunda cincelada",
  "block.minecraft.chiseled_nether_bricks": "Ladrillos del Nether cincelados",
  "block.minecraft.chiseled_polished_blackstone": "Piedra negra pulida cincelada",
  "block.minecraft.chiseled_quartz_block": "Bloque de cuarzo cincelado",
  "block.minecraft.chiseled_red_sandstone": "Arenisca roja cincelada",
  "block.minecraft.chiseled_resin_bricks": "Ladrillos de resina cincelados",
  "block.minecraft.chiseled_sandstone": "Arenisca cincelada",
  "block.minecraft.chiseled_stone_bricks": "Ladrillos de piedra cincelados",
  "block.minecraft.chiseled_tuff": "Toba cincelada",
  "block.minecraft.chiseled_tuff_bricks": "Ladrillos de toba cincelados",
  "block.minecraft.chorus_flower": "Flor de chorus",
  "block.minecraft.chorus_plant": "Chorus",
  "block.minecraft.clay": "Arcilla",
  "block.minecraft.closed_eyeblossom": "Flor de ojo cerrada",
  "block.minecraft.coal_block": "Bloque de carbón",
  "block.minecraft.coal_ore": "Mineral de carbón",
  "block.minecraft.coarse_dirt": "Tierra infértil",
  "block.minecraft.cobbled_deepslate": "Piedra labrada profunda",
  "block.minecraft.cobbled_deepslate_slab": "Losa de piedra labrada profunda",
  "block.minecraft.cobbled_deepslate_stairs": "Escaleras de piedra labrada profunda",
  "block.minecraft.cobbled_deepslate_wall": "Muro de piedra labrada profunda",
  "block.minecraft.cobblestone": "Piedra labrada",
  "block.minecraft.cobblestone_slab": "Losa de piedra labrada",
  "block.minecraft.cobblestone_stairs": "Escaleras de piedra labrada",
  "block.minecraft.cobblestone_wall": "Muro de piedra labrada",
  "block.minecraft.cobweb": "Telaraña",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Bloque de comandos",
  "block.minecraft.comparator": "Comparador de redstone",
  "block.minecraft.composter": "Compostador",
  "block.minecraft.conduit": "Canalizador",
  "block.minecraft.copper_bars": "Barras de cobre",
  "block.minecraft.copper_block": "Bloque de cobre",
  "block.minecraft.copper_bulb": "Lámpara de cobre",
  "block.minecraft.copper_chain": "Cadena de cobre",
  "block.minecraft.copper_chest": "Cofre de cobre",
  "block.minecraft.copper_door": "Puerta de cobre",
  "block.minecraft.copper_golem_statue": "Estatua de gólem de cobre",
  "block.minecraft.copper_grate": "Rejilla de cobre",
  "block.minecraft.copper_lantern": "Farol de cobre",
  "block.minecraft.copper_ore": "Mineral de cobre",
  "block.minecraft.copper_torch": "Antorcha de cobre",
  "block.minecraft.copper_trapdoor": "Trampilla de cobre",
  "block.minecraft.copper_wall_torch": "Antorcha de cobre en pared",
  "block.minecraft.cornflower": "Aciano",
  "block.minecraft.cracked_deepslate_bricks": "Ladrillos de piedra profunda agrietados",
  "block.minecraft.cracked_deepslate_tiles": "Cerámica de piedra profunda agrietada",
  "block.minecraft.cracked_nether_bricks": "Ladrillos del Nether agrietados",
  "block.minecraft.cracked_polished_blackstone_bricks": "Ladrillos de piedra negra pulida agrietados",
  "block.minecraft.cracked_stone_bricks": "Ladrillos de piedra agrietados",
  "block.minecraft.crafter": "Fabricador",
  "block.minecraft.crafting_table": "Mesa de trabajo",
  "block.minecraft.creaking_heart": "Corazón de crujidor",
  "block.minecraft.creeper_head": "Cabeza de creeper",
  "block.minecraft.creeper_wall_head": "Cabeza de creeper en pared",
  "block.minecraft.crimson_button": "Botón carmesí",
  "block.minecraft.crimson_door": "Puerta carmesí",
  "block.minecraft.crimson_fence": "Cerca carmesí",
  "block.minecraft.crimson_fence_gate": "Puerta de cerca carmesí",
  "block.minecraft.crimson_fungus": "Champiñón carmesí",
  "block.minecraft.crimson_hanging_sign": "Letrero colgante carmesí",
  "block.minecraft.crimson_hyphae": "Hifas carmesí",
  "block.minecraft.crimson_nylium": "Nilio carmesí",
  "block.minecraft.crimson_planks": "Tablas carmesí",
  "block.minecraft.crimson_pressure_plate": "Placa de presión carmesí",
  "block.minecraft.crimson_roots": "Raíces carmesí",
  "block.minecraft.crimson_shelf": "Estante carmesí",
  "block.minecraft.crimson_sign": "Letrero carmesí",
  "block.minecraft.crimson_slab": "Losa carmesí",
  "block.minecraft.crimson_stairs": "Escaleras carmesí",
  "block.minecraft.crimson_stem": "Tallo carmesí",
  "block.minecraft.crimson_trapdoor": "Trampilla carmesí",
  "block.minecraft.crimson_wall_hanging_sign": "Letrero colgante carmesí en pared",
  "block.minecraft.crimson_wall_sign": "Letrero carmesí en pared",
  "block.minecraft.crying_obsidian": "Obsidiana llorosa",
  "block.minecraft.cut_copper": "Cobre cortado",
  "block.minecraft.cut_copper_slab": "Losa de cobre cortado",
  "block.minecraft.cut_copper_stairs": "Escaleras de cobre cortado",
  "block.minecraft.cut_red_sandstone": "Arenisca roja cortada",
  "block.minecraft.cut_red_sandstone_slab": "Losa de arenisca roja cortada",
  "block.minecraft.cut_sandstone": "Arenisca cortada",
  "block.minecraft.cut_sandstone_slab": "Losa de arenisca cortada",
  "block.minecraft.cyan_banner": "Estandarte turquesa",
  "block.minecraft.cyan_bed": "Cama turquesa",
  "block.minecraft.cyan_candle": "Vela turquesa",
  "block.minecraft.cyan_candle_cake": "Pastel con vela turquesa",
  "block.minecraft.cyan_carpet": "Alfombra turquesa",
  "block.minecraft.cyan_concrete": "Concreto turquesa",
  "block.minecraft.cyan_concrete_powder": "Cemento turquesa",
  "block.minecraft.cyan_glazed_terracotta": "Azulejo turquesa",
  "block.minecraft.cyan_shulker_box": "Caja de shulker turquesa",
  "block.minecraft.cyan_stained_glass": "Cristal turquesa",
  "block.minecraft.cyan_stained_glass_pane": "Panel de vidrio turquesa",
  "block.minecraft.cyan_terracotta": "Terracota turquesa",
  "block.minecraft.cyan_wool": "Lana turquesa",
  "block.minecraft.damaged_anvil": "Yunque muy dañado",
  "block.minecraft.dandelion": "Diente de león",
  "block.minecraft.dark_oak_button": "Botón de roble oscuro",
  "block.minecraft.dark_oak_door": "Puerta de roble oscuro",
  "block.minecraft.dark_oak_fence": "Cerca de roble oscuro",
  "block.minecraft.dark_oak_fence_gate": "Puerta de cerca de roble oscuro",
  "block.minecraft.dark_oak_hanging_sign": "Letrero colgante de roble oscuro",
  "block.minecraft.dark_oak_leaves": "Hojas de roble oscuro",
  "block.minecraft.dark_oak_log": "Tronco de roble oscuro",
  "block.minecraft.dark_oak_planks": "Tablas de roble oscuro",
  "block.minecraft.dark_oak_pressure_plate": "Placa de presión de roble oscuro",
  "block.minecraft.dark_oak_sapling": "Retoño de roble oscuro",
  "block.minecraft.dark_oak_shelf": "Estante de roble oscuro",
  "block.minecraft.dark_oak_sign": "Letrero de roble oscuro",
  "block.minecraft.dark_oak_slab": "Losa de roble oscuro",
  "block.minecraft.dark_oak_stairs": "Escaleras de roble oscuro",
  "block.minecraft.dark_oak_trapdoor": "Trampilla de roble oscuro",
  "block.minecraft.dark_oak_wall_hanging_sign": "Letrero colgante de roble oscuro en pared",
  "block.minecraft.dark_oak_wall_sign": "Letrero de roble oscuro en pared",
  "block.minecraft.dark_oak_wood": "Leño de roble oscuro",
  "block.minecraft.dark_prismarine": "Prismarina oscura",
  "block.minecraft.dark_prismarine_slab": "Losa de prismarina oscura",
  "block.minecraft.dark_prismarine_stairs": "Escaleras de prismarina oscura",
  "block.minecraft.daylight_detector": "Sensor de luz ambiental",
  "block.minecraft.dead_brain_coral": "Coral de cerebro muerto",
  "block.minecraft.dead_brain_coral_block": "Bloque de coral de cerebro muerto",
  "block.minecraft.dead_brain_coral_fan": "Gorgonia de cerebro muerta",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgonia de cerebro muerta en pared",
  "block.minecraft.dead_bubble_coral": "Coral de burbuja muerto",
  "block.minecraft.dead_bubble_coral_block": "Bloque de coral de burbuja muerto",
  "block.minecraft.dead_bubble_coral_fan": "Gorgonia de burbuja muerta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgonia de burbuja muerta en pared",
  "block.minecraft.dead_bush": "Arbusto muerto",
  "block.minecraft.dead_fire_coral": "Coral de fuego muerto",
  "block.minecraft.dead_fire_coral_block": "Bloque de coral de fuego muerto",
  "block.minecraft.dead_fire_coral_fan": "Gorgonia de fuego muerta",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgonia de fuego muerta en pared",
  "block.minecraft.dead_horn_coral": "Coral de cuerno muerto",
  "block.minecraft.dead_horn_coral_block": "Bloque de coral de cuerno muerto",
  "block.minecraft.dead_horn_coral_fan": "Gorgonia de cuerno muerta",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgonia de cuerno muerta en pared",
  "block.minecraft.dead_tube_coral": "Coral de tubo muerto",
  "block.minecraft.dead_tube_coral_block": "Bloque de coral de tubo muerto",
  "block.minecraft.dead_tube_coral_fan": "Gorgonia de tubo muerta",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgonia de tubo muerta en pared",
  "block.minecraft.decorated_pot": "Vasija decorada",
  "block.minecraft.deepslate": "Piedra profunda",
  "block.minecraft.deepslate_brick_slab": "Losa de ladrillos de piedra profunda",
  "block.minecraft.deepslate_brick_stairs": "Escaleras de ladrillos de piedra profunda",
  "block.minecraft.deepslate_brick_wall": "Muro de ladrillos de piedra profunda",
  "block.minecraft.deepslate_bricks": "Ladrillos de piedra profunda",
  "block.minecraft.deepslate_coal_ore": "Mineral de carbón profundo",
  "block.minecraft.deepslate_copper_ore": "Mineral de cobre profundo",
  "block.minecraft.deepslate_diamond_ore": "Mineral de diamante profundo",
  "block.minecraft.deepslate_emerald_ore": "Mineral de esmeralda profunda",
  "block.minecraft.deepslate_gold_ore": "Mineral de oro profundo",
  "block.minecraft.deepslate_iron_ore": "Mineral de hierro profundo",
  "block.minecraft.deepslate_lapis_ore": "Mineral de lapizlázuli profundo",
  "block.minecraft.deepslate_redstone_ore": "Mineral de redstone profunda",
  "block.minecraft.deepslate_tile_slab": "Losa de cerámica de piedra profunda",
  "block.minecraft.deepslate_tile_stairs": "Escaleras de cerámica de piedra profunda",
  "block.minecraft.deepslate_tile_wall": "Muro de cerámica de piedra profunda",
  "block.minecraft.deepslate_tiles": "Cerámica de piedra profunda",
  "block.minecraft.detector_rail": "Riel detector",
  "block.minecraft.diamond_block": "Bloque de diamante",
  "block.minecraft.diamond_ore": "Mineral de diamante",
  "block.minecraft.diorite": "Diorita",
  "block.minecraft.diorite_slab": "Losa de diorita",
  "block.minecraft.diorite_stairs": "Escaleras de diorita",
  "block.minecraft.diorite_wall": "Muro de diorita",
  "block.minecraft.dirt": "Tierra",
  "block.minecraft.dirt_path": "Camino de tierra",
  "block.minecraft.dispenser": "Dispensador",
  "block.minecraft.dragon_egg": "Huevo de dragón",
  "block.minecraft.dragon_head": "Cabeza de dragón",
  "block.minecraft.dragon_wall_head": "Cabeza de dragón en pared",
  "block.minecraft.dried_ghast": "Ghast seco",
  "block.minecraft.dried_kelp_block": "Bloque de algas secas",
  "block.minecraft.dripstone_block": "Espeleotema",
  "block.minecraft.dropper": "Soltador",
  "block.minecraft.emerald_block": "Bloque de esmeralda",
  "block.minecraft.emerald_ore": "Mineral de esmeralda",
  "block.minecraft.enchanting_table": "Mesa de encantamientos",
  "block.minecraft.end_gateway": "Acceso al End",
  "block.minecraft.end_portal": "Marco del portal del End",
  "block.minecraft.end_portal_frame": "Marco del portal del End",
  "block.minecraft.end_rod": "Vara del End",
  "block.minecraft.end_stone": "Piedra del End",
  "block.minecraft.end_stone_brick_slab": "Losa de ladrillos de piedra del End",
  "block.minecraft.end_stone_brick_stairs": "Escaleras de ladrillos de piedra del End",
  "block.minecraft.end_stone_brick_wall": "Muro de ladrillos de piedra del End",
  "block.minecraft.end_stone_bricks": "Ladrillos de piedra del End",
  "block.minecraft.ender_chest": "Cofre de ender",
  "block.minecraft.exposed_chiseled_copper": "Cobre cincelado expuesto",
  "block.minecraft.exposed_copper": "Cobre expuesto",
  "block.minecraft.exposed_copper_bars": "Barras de cobre expuesto",
  "block.minecraft.exposed_copper_bulb": "Lámpara de cobre expuesto",
  "block.minecraft.exposed_copper_chain": "Cadena de cobre expuesta",
  "block.minecraft.exposed_copper_chest": "Cofre de cobre expuesto",
  "block.minecraft.exposed_copper_door": "Puerta de cobre expuesto",
  "block.minecraft.exposed_copper_golem_statue": "Estatua de gólem de cobre expuesto",
  "block.minecraft.exposed_copper_grate": "Rejilla de cobre expuesto",
  "block.minecraft.exposed_copper_lantern": "Farol de cobre expuesto",
  "block.minecraft.exposed_copper_trapdoor": "Trampilla de cobre expuesto",
  "block.minecraft.exposed_cut_copper": "Cobre cortado expuesto",
  "block.minecraft.exposed_cut_copper_slab": "Losa de cobre cortado expuesto",
  "block.minecraft.exposed_cut_copper_stairs": "Escaleras de cobre cortado expuesto",
  "block.minecraft.exposed_lightning_rod": "Pararrayos expuesto",
  "block.minecraft.farmland": "Tierra de cultivo",
  "block.minecraft.fern": "Helecho",
  "block.minecraft.fire": "Fuego",
  "block.minecraft.fire_coral": "Coral de fuego",
  "block.minecraft.fire_coral_block": "Bloque de coral de fuego",
  "block.minecraft.fire_coral_fan": "Gorgonia de fuego",
  "block.minecraft.fire_coral_wall_fan": "Gorgonia de fuego en pared",
  "block.minecraft.firefly_bush": "Arbusto de luciérnagas",
  "block.minecraft.fletching_table": "Mesa de arquería",
  "block.minecraft.flower_pot": "Maceta",
  "block.minecraft.flowering_azalea": "Azalea floreciente",
  "block.minecraft.flowering_azalea_leaves": "Hojas de azalea floreciente",
  "block.minecraft.frogspawn": "Huevos de rana",
  "block.minecraft.frosted_ice": "Hielo escarchado",
  "block.minecraft.furnace": "Horno",
  "block.minecraft.gilded_blackstone": "Piedra negra áurea",
  "block.minecraft.glass": "Vidrio",
  "block.minecraft.glass_pane": "Panel de vidrio",
  "block.minecraft.glow_lichen": "Liquen luminoso",
  "block.minecraft.glowstone": "Piedra luminosa",
  "block.minecraft.gold_block": "Bloque de oro",
  "block.minecraft.gold_ore": "Mineral de oro",
  "block.minecraft.golden_dandelion": "Diente de león de oro",
  "block.minecraft.granite": "Granito",
  "block.minecraft.granite_slab": "Losa de granito",
  "block.minecraft.granite_stairs": "Escaleras de granito",
  "block.minecraft.granite_wall": "Muro de granito",
  "block.minecraft.grass": "Hierba",
  "block.minecraft.grass_block": "Bloque de hierba",
  "block.minecraft.gravel": "Grava",
  "block.minecraft.gray_banner": "Estandarte gris",
  "block.minecraft.gray_bed": "Cama gris",
  "block.minecraft.gray_candle": "Vela gris",
  "block.minecraft.gray_candle_cake": "Pastel con vela gris",
  "block.minecraft.gray_carpet": "Alfombra gris",
  "block.minecraft.gray_concrete": "Concreto gris",
  "block.minecraft.gray_concrete_powder": "Cemento gris",
  "block.minecraft.gray_glazed_terracotta": "Azulejo gris",
  "block.minecraft.gray_shulker_box": "Caja de shulker gris",
  "block.minecraft.gray_stained_glass": "Vidrio gris",
  "block.minecraft.gray_stained_glass_pane": "Panel de vidrio gris",
  "block.minecraft.gray_terracotta": "Terracota gris",
  "block.minecraft.gray_wool": "Lana gris",
  "block.minecraft.green_banner": "Estandarte verde",
  "block.minecraft.green_bed": "Cama verde",
  "block.minecraft.green_candle": "Vela verde",
  "block.minecraft.green_candle_cake": "Pastel con vela verde",
  "block.minecraft.green_carpet": "Alfombra verde",
  "block.minecraft.green_concrete": "Concreto verde",
  "block.minecraft.green_concrete_powder": "Cemento verde",
  "block.minecraft.green_glazed_terracotta": "Azulejo verde",
  "block.minecraft.green_shulker_box": "Caja de shulker verde",
  "block.minecraft.green_stained_glass": "Vidrio verde",
  "block.minecraft.green_stained_glass_pane": "Panel de vidrio verde",
  "block.minecraft.green_terracotta": "Terracota verde",
  "block.minecraft.green_wool": "Lana verde",
  "block.minecraft.grindstone": "Afiladora",
  "block.minecraft.hanging_roots": "Raíces colgantes",
  "block.minecraft.hay_block": "Fardo de heno",
  "block.minecraft.heavy_core": "Núcleo pesado",
  "block.minecraft.heavy_weighted_pressure_plate": "Placa de presión para peso elevado",
  "block.minecraft.honey_block": "Bloque de miel",
  "block.minecraft.honeycomb_block": "Bloque de panal",
  "block.minecraft.hopper": "Tolva",
  "block.minecraft.horn_coral": "Coral de cuerno",
  "block.minecraft.horn_coral_block": "Bloque de coral de cuerno",
  "block.minecraft.horn_coral_fan": "Gorgonia de cuerno",
  "block.minecraft.horn_coral_wall_fan": "Gorgonia de cuerno en pared",
  "block.minecraft.ice": "Hielo",
  "block.minecraft.infested_chiseled_stone_bricks": "Ladrillos de piedra cincelados infestados",
  "block.minecraft.infested_cobblestone": "Piedra labrada infestada",
  "block.minecraft.infested_cracked_stone_bricks": "Ladrillos de piedra agrietados infestados",
  "block.minecraft.infested_deepslate": "Piedra profunda infestada",
  "block.minecraft.infested_mossy_stone_bricks": "Ladrillos de piedra musgosa infestados",
  "block.minecraft.infested_stone": "Piedra infestada",
  "block.minecraft.infested_stone_bricks": "Ladrillos de piedra infestados",
  "block.minecraft.iron_bars": "Barrotes de hierro",
  "block.minecraft.iron_block": "Bloque de hierro",
  "block.minecraft.iron_chain": "Cadena de hierro",
  "block.minecraft.iron_door": "Puerta de hierro",
  "block.minecraft.iron_ore": "Mineral de hierro",
  "block.minecraft.iron_trapdoor": "Trampilla de hierro",
  "block.minecraft.jack_o_lantern": "Calabaza de Halloween",
  "block.minecraft.jigsaw": "Bloque de rompecabezas",
  "block.minecraft.jukebox": "Tocadiscos",
  "block.minecraft.jungle_button": "Botón de jungla",
  "block.minecraft.jungle_door": "Puerta de jungla",
  "block.minecraft.jungle_fence": "Cerca de jungla",
  "block.minecraft.jungle_fence_gate": "Puerta de cerca de jungla",
  "block.minecraft.jungle_hanging_sign": "Letrero colgante de jungla",
  "block.minecraft.jungle_leaves": "Hojas de jungla",
  "block.minecraft.jungle_log": "Tronco de jungla",
  "block.minecraft.jungle_planks": "Tablas de jungla",
  "block.minecraft.jungle_pressure_plate": "Placa de presión de jungla",
  "block.minecraft.jungle_sapling": "Retoño de jungla",
  "block.minecraft.jungle_shelf": "Estante de jungla",
  "block.minecraft.jungle_sign": "Letrero de jungla",
  "block.minecraft.jungle_slab": "Losa de jungla",
  "block.minecraft.jungle_stairs": "Escaleras de jungla",
  "block.minecraft.jungle_trapdoor": "Trampilla de jungla",
  "block.minecraft.jungle_wall_hanging_sign": "Letrero colgante de jungla en pared",
  "block.minecraft.jungle_wall_sign": "Letrero de jungla en pared",
  "block.minecraft.jungle_wood": "Leño de jungla",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Tallo de alga",
  "block.minecraft.ladder": "Escalera de mano",
  "block.minecraft.lantern": "Farol",
  "block.minecraft.lapis_block": "Bloque de Lapislázuli",
  "block.minecraft.lapis_ore": "Mineral de lapislázuli",
  "block.minecraft.large_amethyst_bud": "Brote grande de amatista",
  "block.minecraft.large_fern": "Helecho grande",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Caldero con lava",
  "block.minecraft.leaf_litter": "Hojas secas",
  "block.minecraft.lectern": "Atril",
  "block.minecraft.lever": "Palanca",
  "block.minecraft.light": "Luz",
  "block.minecraft.light_blue_banner": "Estandarte celeste",
  "block.minecraft.light_blue_bed": "Cama celeste",
  "block.minecraft.light_blue_candle": "Vela celeste",
  "block.minecraft.light_blue_candle_cake": "Pastel con vela celeste",
  "block.minecraft.light_blue_carpet": "Alfombra celeste",
  "block.minecraft.light_blue_concrete": "Concreto celeste",
  "block.minecraft.light_blue_concrete_powder": "Cemento celeste",
  "block.minecraft.light_blue_glazed_terracotta": "Azulejo celeste",
  "block.minecraft.light_blue_shulker_box": "Caja de shulker celeste",
  "block.minecraft.light_blue_stained_glass": "Vidrio celeste",
  "block.minecraft.light_blue_stained_glass_pane": "Panel de vidrio celeste",
  "block.minecraft.light_blue_terracotta": "Terracota celeste",
  "block.minecraft.light_blue_wool": "Lana celeste",
  "block.minecraft.light_gray_banner": "Estandarte gris claro",
  "block.minecraft.light_gray_bed": "Cama gris claro",
  "block.minecraft.light_gray_candle": "Vela gris claro",
  "block.minecraft.light_gray_candle_cake": "Pastel con vela gris claro",
  "block.minecraft.light_gray_carpet": "Alfombra gris claro",
  "block.minecraft.light_gray_concrete": "Concreto gris claro",
  "block.minecraft.light_gray_concrete_powder": "Cemento gris claro",
  "block.minecraft.light_gray_glazed_terracotta": "Azulejo gris claro",
  "block.minecraft.light_gray_shulker_box": "Caja de shulker gris claro",
  "block.minecraft.light_gray_stained_glass": "Vidrio gris claro",
  "block.minecraft.light_gray_stained_glass_pane": "Panel de vidrio gris claro",
  "block.minecraft.light_gray_terracotta": "Terracota gris claro",
  "block.minecraft.light_gray_wool": "Lana gris claro",
  "block.minecraft.light_weighted_pressure_plate": "Placa de presión para peso liviano",
  "block.minecraft.lightning_rod": "Pararrayos",
  "block.minecraft.lilac": "Lila",
  "block.minecraft.lily_of_the_valley": "Lirio del valle",
  "block.minecraft.lily_pad": "Nenúfar",
  "block.minecraft.lime_banner": "Estandarte verde lima",
  "block.minecraft.lime_bed": "Cama verde lima",
  "block.minecraft.lime_candle": "Vela verde lima",
  "block.minecraft.lime_candle_cake": "Pastel con vela verde lima",
  "block.minecraft.lime_carpet": "Alfombra verde lima",
  "block.minecraft.lime_concrete": "Concreto verde lima",
  "block.minecraft.lime_concrete_powder": "Cemento verde lima",
  "block.minecraft.lime_glazed_terracotta": "Azulejo verde lima",
  "block.minecraft.lime_shulker_box": "Caja de shulker verde lima",
  "block.minecraft.lime_stained_glass": "Vidrio verde lima",
  "block.minecraft.lime_stained_glass_pane": "Panel de vidrio verde lima",
  "block.minecraft.lime_terracotta": "Terracota verde lima",
  "block.minecraft.lime_wool": "Lana verde lima",
  "block.minecraft.lodestone": "Magnetita",
  "block.minecraft.loom": "Telar",
  "block.minecraft.magenta_banner": "Estandarte fucsia",
  "block.minecraft.magenta_bed": "Cama fucsia",
  "block.minecraft.magenta_candle": "Vela fucsia",
  "block.minecraft.magenta_candle_cake": "Pastel con vela fucsia",
  "block.minecraft.magenta_carpet": "Alfombra fucsia",
  "block.minecraft.magenta_concrete": "Concreto fucsia",
  "block.minecraft.magenta_concrete_powder": "Cemento fucsia",
  "block.minecraft.magenta_glazed_terracotta": "Azulejo fucsia",
  "block.minecraft.magenta_shulker_box": "Caja de shulker fucsia",
  "block.minecraft.magenta_stained_glass": "Vidrio fucsia",
  "block.minecraft.magenta_stained_glass_pane": "Panel de vidrio fucsia",
  "block.minecraft.magenta_terracotta": "Terracota fucsia",
  "block.minecraft.magenta_wool": "Lana fucsia",
  "block.minecraft.magma_block": "Bloque de magma",
  "block.minecraft.mangrove_button": "Botón de mangle",
  "block.minecraft.mangrove_door": "Puerta de mangle",
  "block.minecraft.mangrove_fence": "Cerca de mangle",
  "block.minecraft.mangrove_fence_gate": "Puerta de cerca de mangle",
  "block.minecraft.mangrove_hanging_sign": "Letrero colgante de mangle",
  "block.minecraft.mangrove_leaves": "Hojas de mangle",
  "block.minecraft.mangrove_log": "Tronco de mangle",
  "block.minecraft.mangrove_planks": "Tablas de mangle",
  "block.minecraft.mangrove_pressure_plate": "Placa de presión de mangle",
  "block.minecraft.mangrove_propagule": "Propágulo de mangle",
  "block.minecraft.mangrove_roots": "Raíces de mangle",
  "block.minecraft.mangrove_shelf": "Estante de mangle",
  "block.minecraft.mangrove_sign": "Letrero de mangle",
  "block.minecraft.mangrove_slab": "Losa de mangle",
  "block.minecraft.mangrove_stairs": "Escalera de mangle",
  "block.minecraft.mangrove_trapdoor": "Trampilla de mangle",
  "block.minecraft.mangrove_wall_hanging_sign": "Letrero colgante de mangle en pared",
  "block.minecraft.mangrove_wall_sign": "Letrero de mangle en pared",
  "block.minecraft.mangrove_wood": "Leño de mangle",
  "block.minecraft.medium_amethyst_bud": "Brote mediano de amatista",
  "block.minecraft.melon": "Sandía",
  "block.minecraft.melon_stem": "Tallo de sandía",
  "block.minecraft.moss_block": "Bloque de musgo",
  "block.minecraft.moss_carpet": "Alfombra musgosa",
  "block.minecraft.mossy_cobblestone": "Piedra labrada musgosa",
  "block.minecraft.mossy_cobblestone_slab": "Losa de piedra labrada musgosa",
  "block.minecraft.mossy_cobblestone_stairs": "Escaleras de piedra labrada musgosa",
  "block.minecraft.mossy_cobblestone_wall": "Muro de piedra labrada musgosa",
  "block.minecraft.mossy_stone_brick_slab": "Losa de ladrillos de piedra musgosa",
  "block.minecraft.mossy_stone_brick_stairs": "Escaleras de ladrillos de piedra musgosa",
  "block.minecraft.mossy_stone_brick_wall": "Muro de ladrillos de piedra musgosa",
  "block.minecraft.mossy_stone_bricks": "Ladrillos de piedra musgosa",
  "block.minecraft.moving_piston": "Pistón en movimiento",
  "block.minecraft.mud": "Lodo",
  "block.minecraft.mud_brick_slab": "Losa de ladrillos de adobe",
  "block.minecraft.mud_brick_stairs": "Escalera de ladrillos de adobe",
  "block.minecraft.mud_brick_wall": "Muro de ladrillos de adobe",
  "block.minecraft.mud_bricks": "Ladrillos de adobe",
  "block.minecraft.muddy_mangrove_roots": "Raíces de mangle lodosas",
  "block.minecraft.mushroom_stem": "Tallo de champiñón",
  "block.minecraft.mycelium": "Micelio",
  "block.minecraft.nether_brick_fence": "Cerca de ladrillos del Nether",
  "block.minecraft.nether_brick_slab": "Losa de ladrillos del Nether",
  "block.minecraft.nether_brick_stairs": "Escaleras de ladrillos del Nether",
  "block.minecraft.nether_brick_wall": "Muro de ladrillos del Nether",
  "block.minecraft.nether_bricks": "Ladrillos del Nether",
  "block.minecraft.nether_gold_ore": "Mineral de oro del Nether",
  "block.minecraft.nether_portal": "Portal al Nether",
  "block.minecraft.nether_quartz_ore": "Mineral de cuarzo del Nether",
  "block.minecraft.nether_sprouts": "Rastrojo del Nether",
  "block.minecraft.nether_wart": "Verruga del Nether",
  "block.minecraft.nether_wart_block": "Bloque de verrugas del Nether",
  "block.minecraft.netherite_block": "Bloque de netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloque musical",
  "block.minecraft.oak_button": "Botón de roble",
  "block.minecraft.oak_door": "Puerta de roble",
  "block.minecraft.oak_fence": "Cerca de roble",
  "block.minecraft.oak_fence_gate": "Puerta de cerca de roble",
  "block.minecraft.oak_hanging_sign": "Letrero colgante de roble",
  "block.minecraft.oak_leaves": "Hojas de roble",
  "block.minecraft.oak_log": "Tronco de roble",
  "block.minecraft.oak_planks": "Tablas de roble",
  "block.minecraft.oak_pressure_plate": "Placa de presión de roble",
  "block.minecraft.oak_sapling": "Retoño de roble",
  "block.minecraft.oak_shelf": "Estante de roble",
  "block.minecraft.oak_sign": "Letrero de roble",
  "block.minecraft.oak_slab": "Losa de roble",
  "block.minecraft.oak_stairs": "Escaleras de roble",
  "block.minecraft.oak_trapdoor": "Trampilla de roble",
  "block.minecraft.oak_wall_hanging_sign": "Letrero colgante de roble en pared",
  "block.minecraft.oak_wall_sign": "Letrero de roble en pared",
  "block.minecraft.oak_wood": "Leño de roble",
  "block.minecraft.observer": "Observador",
  "block.minecraft.obsidian": "Obsidiana",
  "block.minecraft.ochre_froglight": "Ranaluz ocre",
  "block.minecraft.ominous_banner": "Estandarte del mal presagio",
  "block.minecraft.open_eyeblossom": "Flor de ojo abierta",
  "block.minecraft.orange_banner": "Estandarte naranja",
  "block.minecraft.orange_bed": "Cama naranja",
  "block.minecraft.orange_candle": "Vela naranja",
  "block.minecraft.orange_candle_cake": "Pastel con vela naranja",
  "block.minecraft.orange_carpet": "Alfombra naranja",
  "block.minecraft.orange_concrete": "Concreto naranja",
  "block.minecraft.orange_concrete_powder": "Cemento naranja",
  "block.minecraft.orange_glazed_terracotta": "Azulejo naranja",
  "block.minecraft.orange_shulker_box": "Caja de shulker naranja",
  "block.minecraft.orange_stained_glass": "Vidrio naranja",
  "block.minecraft.orange_stained_glass_pane": "Panel de vidrio naranja",
  "block.minecraft.orange_terracotta": "Terracota naranja",
  "block.minecraft.orange_tulip": "Tulipán naranja",
  "block.minecraft.orange_wool": "Lana naranja",
  "block.minecraft.oxeye_daisy": "Margarita",
  "block.minecraft.oxidized_chiseled_copper": "Cobre cincelado oxidado",
  "block.minecraft.oxidized_copper": "Cobre oxidado",
  "block.minecraft.oxidized_copper_bars": "Barras de cobre oxidado",
  "block.minecraft.oxidized_copper_bulb": "Lámpara de cobre oxidado",
  "block.minecraft.oxidized_copper_chain": "Cadena de cobre oxidado",
  "block.minecraft.oxidized_copper_chest": "Cofre de cobre oxidado",
  "block.minecraft.oxidized_copper_door": "Puerta de cobre oxidado",
  "block.minecraft.oxidized_copper_golem_statue": "Estatua de gólem de cobre oxidado",
  "block.minecraft.oxidized_copper_grate": "Rejilla de cobre oxidado",
  "block.minecraft.oxidized_copper_lantern": "Farol de cobre oxidado",
  "block.minecraft.oxidized_copper_trapdoor": "Trampilla de cobre oxidado",
  "block.minecraft.oxidized_cut_copper": "Cobre cortado oxidado",
  "block.minecraft.oxidized_cut_copper_slab": "Losa de cobre cortado oxidado",
  "block.minecraft.oxidized_cut_copper_stairs": "Escaleras de cobre cortado oxidado",
  "block.minecraft.oxidized_lightning_rod": "Pararrayos oxidado",
  "block.minecraft.packed_ice": "Hielo compacto",
  "block.minecraft.packed_mud": "Adobe",
  "block.minecraft.pale_hanging_moss": "Musgo pálido colgante",
  "block.minecraft.pale_moss_block": "Bloque de musgo pálido",
  "block.minecraft.pale_moss_carpet": "Alfombra musgosa pálida",
  "block.minecraft.pale_oak_button": "Botón de roble pálido",
  "block.minecraft.pale_oak_door": "Puerta de roble pálido",
  "block.minecraft.pale_oak_fence": "Cerca de roble pálido",
  "block.minecraft.pale_oak_fence_gate": "Puerta de cerca de roble pálido",
  "block.minecraft.pale_oak_hanging_sign": "Letrero colgante de roble pálido",
  "block.minecraft.pale_oak_leaves": "Hojas de roble pálido",
  "block.minecraft.pale_oak_log": "Tronco de roble pálido",
  "block.minecraft.pale_oak_planks": "Tablas de roble pálido",
  "block.minecraft.pale_oak_pressure_plate": "Placa de presión de roble pálido",
  "block.minecraft.pale_oak_sapling": "Retoño de roble pálido",
  "block.minecraft.pale_oak_shelf": "Estante de roble pálido",
  "block.minecraft.pale_oak_sign": "Letrero de roble pálido",
  "block.minecraft.pale_oak_slab": "Losa de roble pálido",
  "block.minecraft.pale_oak_stairs": "Escaleras de roble pálido",
  "block.minecraft.pale_oak_trapdoor": "Trampilla de roble pálido",
  "block.minecraft.pale_oak_wall_hanging_sign": "Letrero colgante de roble pálido en pared",
  "block.minecraft.pale_oak_wall_sign": "Letrero de roble pálido en pared",
  "block.minecraft.pale_oak_wood": "Leño de roble pálido",
  "block.minecraft.pearlescent_froglight": "Ranaluz nacarada",
  "block.minecraft.peony": "Peonía",
  "block.minecraft.petrified_oak_slab": "Losa de roble petrificada",
  "block.minecraft.piglin_head": "Cabeza de piglin",
  "block.minecraft.piglin_wall_head": "Cabeza de piglin en pared",
  "block.minecraft.pink_banner": "Estandarte rosado",
  "block.minecraft.pink_bed": "Cama rosada",
  "block.minecraft.pink_candle": "Vela rosa",
  "block.minecraft.pink_candle_cake": "Pastel con vela rosada",
  "block.minecraft.pink_carpet": "Alfombra rosada",
  "block.minecraft.pink_concrete": "Concreto rosado",
  "block.minecraft.pink_concrete_powder": "Cemento rosado",
  "block.minecraft.pink_glazed_terracotta": "Azulejo rosado",
  "block.minecraft.pink_petals": "Pétalos rosados",
  "block.minecraft.pink_shulker_box": "Caja de shulker rosada",
  "block.minecraft.pink_stained_glass": "Vidrio rosado",
  "block.minecraft.pink_stained_glass_pane": "Panel de vidrio rosado",
  "block.minecraft.pink_terracotta": "Terracota rosada",
  "block.minecraft.pink_tulip": "Tulipán rosado",
  "block.minecraft.pink_wool": "Lana rosada",
  "block.minecraft.piston": "Pistón",
  "block.minecraft.piston_head": "Cabeza de pistón",
  "block.minecraft.pitcher_crop": "Cultivo de odre",
  "block.minecraft.pitcher_plant": "Planta odre",
  "block.minecraft.player_head": "Cabeza de jugador",
  "block.minecraft.player_head.named": "Cabeza de %s",
  "block.minecraft.player_wall_head": "Cabeza de jugador en pared",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Espeleotema puntiagudo",
  "block.minecraft.polished_andesite": "Andesita pulida",
  "block.minecraft.polished_andesite_slab": "Losa de andesita pulida",
  "block.minecraft.polished_andesite_stairs": "Escaleras de andesita pulida",
  "block.minecraft.polished_basalt": "Basalto pulido",
  "block.minecraft.polished_blackstone": "Piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_slab": "Losa de ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_stairs": "Escaleras de ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_wall": "Muro de ladrillo de piedra negra pulida",
  "block.minecraft.polished_blackstone_bricks": "Ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_button": "Botón de piedra negra pulida",
  "block.minecraft.polished_blackstone_pressure_plate": "Placa de presión de piedra negra pulida",
  "block.minecraft.polished_blackstone_slab": "Losa de piedra negra pulida",
  "block.minecraft.polished_blackstone_stairs": "Escaleras de piedra negra pulida",
  "block.minecraft.polished_blackstone_wall": "Muro de piedra negra pulida",
  "block.minecraft.polished_deepslate": "Piedra profunda pulida",
  "block.minecraft.polished_deepslate_slab": "Losa de piedra profunda pulida",
  "block.minecraft.polished_deepslate_stairs": "Escaleras de piedra profunda pulida",
  "block.minecraft.polished_deepslate_wall": "Muro de piedra profunda pulida",
  "block.minecraft.polished_diorite": "Diorita pulida",
  "block.minecraft.polished_diorite_slab": "Losa de diorita pulida",
  "block.minecraft.polished_diorite_stairs": "Escaleras de diorita pulida",
  "block.minecraft.polished_granite": "Granito pulido",
  "block.minecraft.polished_granite_slab": "Losa de granito pulido",
  "block.minecraft.polished_granite_stairs": "Escaleras de granito pulido",
  "block.minecraft.polished_tuff": "Toba pulida",
  "block.minecraft.polished_tuff_slab": "Losa de toba pulida",
  "block.minecraft.polished_tuff_stairs": "Escaleras de toba pulida",
  "block.minecraft.polished_tuff_wall": "Muro de toba pulida",
  "block.minecraft.poppy": "Amapola",
  "block.minecraft.potatoes": "Papas",
  "block.minecraft.potted_acacia_sapling": "Maceta con retoño de acacia",
  "block.minecraft.potted_allium": "Maceta con allium",
  "block.minecraft.potted_azalea_bush": "Maceta con azalea",
  "block.minecraft.potted_azure_bluet": "Maceta con rubiácea",
  "block.minecraft.potted_bamboo": "Maceta con bambú",
  "block.minecraft.potted_birch_sapling": "Maceta con retoño de abedul",
  "block.minecraft.potted_blue_orchid": "Maceta con orquídea azul",
  "block.minecraft.potted_brown_mushroom": "Maceta con champiñón café",
  "block.minecraft.potted_cactus": "Maceta con cactus",
  "block.minecraft.potted_cherry_sapling": "Maceta con retoño de cerezo",
  "block.minecraft.potted_closed_eyeblossom": "Maceta con flor de ojo cerrada",
  "block.minecraft.potted_cornflower": "Maceta con aciano",
  "block.minecraft.potted_crimson_fungus": "Maceta con champiñón carmesí",
  "block.minecraft.potted_crimson_roots": "Maceta con raíces carmesí",
  "block.minecraft.potted_dandelion": "Maceta con diente de león",
  "block.minecraft.potted_dark_oak_sapling": "Maceta con retoño de roble oscuro",
  "block.minecraft.potted_dead_bush": "Maceta con arbusto muerto",
  "block.minecraft.potted_fern": "Maceta con helecho",
  "block.minecraft.potted_flowering_azalea_bush": "Maceta con azalea florecida",
  "block.minecraft.potted_golden_dandelion": "Maceta con diente de león de oro",
  "block.minecraft.potted_jungle_sapling": "Maceta con retoño de jungla",
  "block.minecraft.potted_lily_of_the_valley": "Maceta con lirio del valle",
  "block.minecraft.potted_mangrove_propagule": "Propágulo de mangle en maceta",
  "block.minecraft.potted_oak_sapling": "Maceta con retoño de roble",
  "block.minecraft.potted_open_eyeblossom": "Maceta con flor de ojo abierta",
  "block.minecraft.potted_orange_tulip": "Maceta con tulipán naranja",
  "block.minecraft.potted_oxeye_daisy": "Maceta con margarita",
  "block.minecraft.potted_pale_oak_sapling": "Maceta con retoño de roble pálido",
  "block.minecraft.potted_pink_tulip": "Maceta con tulipán rosado",
  "block.minecraft.potted_poppy": "Maceta con amapola",
  "block.minecraft.potted_red_mushroom": "Maceta con champiñón rojo",
  "block.minecraft.potted_red_tulip": "Maceta con tulipán rojo",
  "block.minecraft.potted_spruce_sapling": "Maceta con retoño de pino",
  "block.minecraft.potted_torchflower": "Maceta con anflorcha",
  "block.minecraft.potted_warped_fungus": "Maceta con champiñón distorsionado",
  "block.minecraft.potted_warped_roots": "Maceta con raíces distorsionadas",
  "block.minecraft.potted_white_tulip": "Maceta con tulipán blanco",
  "block.minecraft.potted_wither_rose": "Maceta con rosa del Wither",
  "block.minecraft.powder_snow": "Nieve polvo",
  "block.minecraft.powder_snow_cauldron": "Caldero con nieve polvo",
  "block.minecraft.powered_rail": "Riel propulsor",
  "block.minecraft.prismarine": "Prismarina",
  "block.minecraft.prismarine_brick_slab": "Losa de ladrillos de prismarina",
  "block.minecraft.prismarine_brick_stairs": "Escaleras de ladrillos de prismarina",
  "block.minecraft.prismarine_bricks": "Ladrillos de prismarina",
  "block.minecraft.prismarine_slab": "Losa de prismarina",
  "block.minecraft.prismarine_stairs": "Escaleras de prismarina",
  "block.minecraft.prismarine_wall": "Muro de prismarina",
  "block.minecraft.pumpkin": "Calabaza",
  "block.minecraft.pumpkin_stem": "Tallo de calabaza",
  "block.minecraft.purple_banner": "Estandarte morado",
  "block.minecraft.purple_bed": "Cama morada",
  "block.minecraft.purple_candle": "Vela morada",
  "block.minecraft.purple_candle_cake": "Pastel con vela morada",
  "block.minecraft.purple_carpet": "Alfombra morada",
  "block.minecraft.purple_concrete": "Concreto morado",
  "block.minecraft.purple_concrete_powder": "Cemento morado",
  "block.minecraft.purple_glazed_terracotta": "Azulejo morado",
  "block.minecraft.purple_shulker_box": "Caja de shulker morada",
  "block.minecraft.purple_stained_glass": "Vidrio morado",
  "block.minecraft.purple_stained_glass_pane": "Panel de vidrio morado",
  "block.minecraft.purple_terracotta": "Terracota morada",
  "block.minecraft.purple_wool": "Lana morada",
  "block.minecraft.purpur_block": "Bloque de purpur",
  "block.minecraft.purpur_pillar": "Pilar de purpur",
  "block.minecraft.purpur_slab": "Losa de purpur",
  "block.minecraft.purpur_stairs": "Escaleras de purpur",
  "block.minecraft.quartz_block": "Bloque de cuarzo",
  "block.minecraft.quartz_bricks": "Ladrillos de cuarzo",
  "block.minecraft.quartz_pillar": "Pilar de cuarzo",
  "block.minecraft.quartz_slab": "Losa de cuarzo",
  "block.minecraft.quartz_stairs": "Escaleras de cuarzo",
  "block.minecraft.rail": "Riel",
  "block.minecraft.raw_copper_block": "Bloque de cobre en bruto",
  "block.minecraft.raw_gold_block": "Bloque de oro en bruto",
  "block.minecraft.raw_iron_block": "Bloque de hierro en bruto",
  "block.minecraft.red_banner": "Estandarte rojo",
  "block.minecraft.red_bed": "Cama roja",
  "block.minecraft.red_candle": "Vela roja",
  "block.minecraft.red_candle_cake": "Pastel con vela roja",
  "block.minecraft.red_carpet": "Alfombra roja",
  "block.minecraft.red_concrete": "Concreto rojo",
  "block.minecraft.red_concrete_powder": "Cemento rojo",
  "block.minecraft.red_glazed_terracotta": "Azulejo rojo",
  "block.minecraft.red_mushroom": "Champiñón rojo",
  "block.minecraft.red_mushroom_block": "Bloque de champiñón rojo",
  "block.minecraft.red_nether_brick_slab": "Losa de ladrillos del Nether rojos",
  "block.minecraft.red_nether_brick_stairs": "Escaleras de ladrillos del Nether rojos",
  "block.minecraft.red_nether_brick_wall": "Muro de ladrillos del Nether rojos",
  "block.minecraft.red_nether_bricks": "Ladrillos del Nether rojos",
  "block.minecraft.red_sand": "Arena roja",
  "block.minecraft.red_sandstone": "Arenisca roja",
  "block.minecraft.red_sandstone_slab": "Losa de arenisca roja",
  "block.minecraft.red_sandstone_stairs": "Escaleras de arenisca roja",
  "block.minecraft.red_sandstone_wall": "Muro de arenisca roja",
  "block.minecraft.red_shulker_box": "Caja de shulker roja",
  "block.minecraft.red_stained_glass": "Vidrio rojo",
  "block.minecraft.red_stained_glass_pane": "Panel de vidrio rojo",
  "block.minecraft.red_terracotta": "Terracota roja",
  "block.minecraft.red_tulip": "Tulipán rojo",
  "block.minecraft.red_wool": "Lana roja",
  "block.minecraft.redstone_block": "Bloque de redstone",
  "block.minecraft.redstone_lamp": "Lámpara",
  "block.minecraft.redstone_ore": "Mineral de redstone",
  "block.minecraft.redstone_torch": "Antorcha de redstone",
  "block.minecraft.redstone_wall_torch": "Antorcha de redstone en pared",
  "block.minecraft.redstone_wire": "Cable de redstone",
  "block.minecraft.reinforced_deepslate": "Piedra profunda reforzada",
  "block.minecraft.repeater": "Repetidor de redstone",
  "block.minecraft.repeating_command_block": "Bloque de comandos de repetición",
  "block.minecraft.resin_block": "Bloque de resina",
  "block.minecraft.resin_brick_slab": "Losa de ladrillos de resina",
  "block.minecraft.resin_brick_stairs": "Escaleras de ladrillos de resina",
  "block.minecraft.resin_brick_wall": "Muro de ladrillos de resina",
  "block.minecraft.resin_bricks": "Bloque de ladrillos de resina",
  "block.minecraft.resin_clump": "Resina",
  "block.minecraft.respawn_anchor": "Nexo de reaparición",
  "block.minecraft.rooted_dirt": "Tierra enraizada",
  "block.minecraft.rose_bush": "Rosal",
  "block.minecraft.sand": "Arena",
  "block.minecraft.sandstone": "Arenisca",
  "block.minecraft.sandstone_slab": "Losa de arenisca",
  "block.minecraft.sandstone_stairs": "Escaleras de arenisca",
  "block.minecraft.sandstone_wall": "Muro de arenisca",
  "block.minecraft.scaffolding": "Andamio",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalizador de sculk",
  "block.minecraft.sculk_sensor": "Sensor de sculk",
  "block.minecraft.sculk_shrieker": "Chillador de sculk",
  "block.minecraft.sculk_vein": "Vena de sculk",
  "block.minecraft.sea_lantern": "Linterna marina",
  "block.minecraft.sea_pickle": "Pepino de mar",
  "block.minecraft.seagrass": "Hierba marina",
  "block.minecraft.set_spawn": "Punto de reaparición establecido",
  "block.minecraft.short_dry_grass": "Hierba seca corta",
  "block.minecraft.short_grass": "Hierba corta",
  "block.minecraft.shroomlight": "Champiluz",
  "block.minecraft.shulker_box": "Caja de shulker",
  "block.minecraft.skeleton_skull": "Calavera de esqueleto",
  "block.minecraft.skeleton_wall_skull": "Calavera de esqueleto en pared",
  "block.minecraft.slime_block": "Bloque de slime",
  "block.minecraft.small_amethyst_bud": "Brote pequeño de amatista",
  "block.minecraft.small_dripleaf": "Plantaforma pequeña",
  "block.minecraft.smithing_table": "Mesa de herrería",
  "block.minecraft.smoker": "Ahumador",
  "block.minecraft.smooth_basalt": "Basalto liso",
  "block.minecraft.smooth_quartz": "Bloque de cuarzo liso",
  "block.minecraft.smooth_quartz_slab": "Losa de cuarzo liso",
  "block.minecraft.smooth_quartz_stairs": "Escaleras de cuarzo liso",
  "block.minecraft.smooth_red_sandstone": "Arenisca roja lisa",
  "block.minecraft.smooth_red_sandstone_slab": "Losa de arenisca roja lisa",
  "block.minecraft.smooth_red_sandstone_stairs": "Escaleras de arenisca roja lisa",
  "block.minecraft.smooth_sandstone": "Arenisca lisa",
  "block.minecraft.smooth_sandstone_slab": "Losa de arenisca lisa",
  "block.minecraft.smooth_sandstone_stairs": "Escaleras de arenisca lisa",
  "block.minecraft.smooth_stone": "Piedra lisa",
  "block.minecraft.smooth_stone_slab": "Losa de piedra lisa",
  "block.minecraft.sniffer_egg": "Huevo de sniffer",
  "block.minecraft.snow": "Nieve",
  "block.minecraft.snow_block": "Bloque de nieve",
  "block.minecraft.soul_campfire": "Fogata de almas",
  "block.minecraft.soul_fire": "Fuego de almas",
  "block.minecraft.soul_lantern": "Farol de almas",
  "block.minecraft.soul_sand": "Arena de almas",
  "block.minecraft.soul_soil": "Tierra de almas",
  "block.minecraft.soul_torch": "Antorcha de almas",
  "block.minecraft.soul_wall_torch": "Antorcha de almas en pared",
  "block.minecraft.spawn.not_valid": "No tienes una cama o punto de reaparición, o pueden estar obstruidos",
  "block.minecraft.spawner": "Generador de criaturas",
  "block.minecraft.spawner.desc1": "Interactúa con un huevo generador:",
  "block.minecraft.spawner.desc2": "Establece el tipo de mob",
  "block.minecraft.sponge": "Esponja",
  "block.minecraft.spore_blossom": "Flor de esporas",
  "block.minecraft.spruce_button": "Botón de pino",
  "block.minecraft.spruce_door": "Puerta de pino",
  "block.minecraft.spruce_fence": "Cerca de pino",
  "block.minecraft.spruce_fence_gate": "Puerta de cerca de pino",
  "block.minecraft.spruce_hanging_sign": "Letrero colgante de pino",
  "block.minecraft.spruce_leaves": "Hojas de pino",
  "block.minecraft.spruce_log": "Tronco de pino",
  "block.minecraft.spruce_planks": "Tablas de pino",
  "block.minecraft.spruce_pressure_plate": "Placa de presión de pino",
  "block.minecraft.spruce_sapling": "Retoño de pino",
  "block.minecraft.spruce_shelf": "Estante de abeto",
  "block.minecraft.spruce_sign": "Letrero de pino",
  "block.minecraft.spruce_slab": "Losa de pino",
  "block.minecraft.spruce_stairs": "Escaleras de pino",
  "block.minecraft.spruce_trapdoor": "Trampilla de pino",
  "block.minecraft.spruce_wall_hanging_sign": "Letrero colgante de pino en pared",
  "block.minecraft.spruce_wall_sign": "Letrero de pino en pared",
  "block.minecraft.spruce_wood": "Leño de pino",
  "block.minecraft.sticky_piston": "Pistón pegajoso",
  "block.minecraft.stone": "Piedra",
  "block.minecraft.stone_brick_slab": "Losa de ladrillos de piedra",
  "block.minecraft.stone_brick_stairs": "Escaleras de ladrillos de piedra",
  "block.minecraft.stone_brick_wall": "Muro de ladrillos de piedra",
  "block.minecraft.stone_bricks": "Ladrillos de piedra",
  "block.minecraft.stone_button": "Botón de piedra",
  "block.minecraft.stone_pressure_plate": "Placa de presión de piedra",
  "block.minecraft.stone_slab": "Losa de piedra",
  "block.minecraft.stone_stairs": "Escaleras de piedra",
  "block.minecraft.stonecutter": "Cortapiedras",
  "block.minecraft.stripped_acacia_log": "Tronco de acacia sin corteza",
  "block.minecraft.stripped_acacia_wood": "Leño de acacia sin corteza",
  "block.minecraft.stripped_bamboo_block": "Bloque de bambú sin corteza",
  "block.minecraft.stripped_birch_log": "Tronco de abedul sin corteza",
  "block.minecraft.stripped_birch_wood": "Leño de abedul sin corteza",
  "block.minecraft.stripped_cherry_log": "Tronco de cerezo sin corteza",
  "block.minecraft.stripped_cherry_wood": "Leño de cerezo sin corteza",
  "block.minecraft.stripped_crimson_hyphae": "Hifas carmesí sin corteza",
  "block.minecraft.stripped_crimson_stem": "Tallo carmesí sin corteza",
  "block.minecraft.stripped_dark_oak_log": "Tronco de roble oscuro sin corteza",
  "block.minecraft.stripped_dark_oak_wood": "Leño de roble oscuro sin corteza",
  "block.minecraft.stripped_jungle_log": "Tronco de jungla sin corteza",
  "block.minecraft.stripped_jungle_wood": "Leño de jungla sin corteza",
  "block.minecraft.stripped_mangrove_log": "Tronco de mangle sin corteza",
  "block.minecraft.stripped_mangrove_wood": "Leño de mangle sin corteza",
  "block.minecraft.stripped_oak_log": "Tronco de roble sin corteza",
  "block.minecraft.stripped_oak_wood": "Leño de roble sin corteza",
  "block.minecraft.stripped_pale_oak_log": "Tronco de roble pálido sin corteza",
  "block.minecraft.stripped_pale_oak_wood": "Leño de roble pálido sin corteza",
  "block.minecraft.stripped_spruce_log": "Tronco de pino sin corteza",
  "block.minecraft.stripped_spruce_wood": "Leño de pino sin corteza",
  "block.minecraft.stripped_warped_hyphae": "Hifas distorsionadas sin corteza",
  "block.minecraft.stripped_warped_stem": "Tallo distorsionado sin corteza",
  "block.minecraft.structure_block": "Bloque estructural",
  "block.minecraft.structure_void": "Vacío estructural",
  "block.minecraft.sugar_cane": "Caña de azúcar",
  "block.minecraft.sunflower": "Girasol",
  "block.minecraft.suspicious_gravel": "Grava sospechosa",
  "block.minecraft.suspicious_sand": "Arena sospechosa",
  "block.minecraft.sweet_berry_bush": "Arbusto de frutos dulces",
  "block.minecraft.tall_dry_grass": "Hierba seca alta",
  "block.minecraft.tall_grass": "Hierba alta",
  "block.minecraft.tall_seagrass": "Hierba marina alta",
  "block.minecraft.target": "Diana",
  "block.minecraft.terracotta": "Terracota",
  "block.minecraft.test_block": "Bloque de pruebas",
  "block.minecraft.test_instance_block": "Bloqueo de la prueba de instancia",
  "block.minecraft.tinted_glass": "Vidrio opaco",
  "block.minecraft.tnt": "Dinamita",
  "block.minecraft.tnt.disabled": "Explosiones de dinamita están desactivadas",
  "block.minecraft.torch": "Antorcha",
  "block.minecraft.torchflower": "Anflorcha",
  "block.minecraft.torchflower_crop": "Cultivo de anflorcha",
  "block.minecraft.trapped_chest": "Cofre trampa",
  "block.minecraft.trial_spawner": "Generador de desafío",
  "block.minecraft.tripwire": "Hilo de activación",
  "block.minecraft.tripwire_hook": "Gancho",
  "block.minecraft.tube_coral": "Coral de tubo",
  "block.minecraft.tube_coral_block": "Bloque de coral de tubo",
  "block.minecraft.tube_coral_fan": "Gorgonia de tubo",
  "block.minecraft.tube_coral_wall_fan": "Gorgonia de tubo en pared",
  "block.minecraft.tuff": "Toba",
  "block.minecraft.tuff_brick_slab": "Losa de ladrillos de toba",
  "block.minecraft.tuff_brick_stairs": "Escaleras de ladrillos de toba",
  "block.minecraft.tuff_brick_wall": "Muro de ladrillos de toba",
  "block.minecraft.tuff_bricks": "Ladrillos de toba",
  "block.minecraft.tuff_slab": "Losa de toba",
  "block.minecraft.tuff_stairs": "Escaleras de toba",
  "block.minecraft.tuff_wall": "Muro de toba",
  "block.minecraft.turtle_egg": "Huevo de tortuga",
  "block.minecraft.twisting_vines": "Lianas retorcidas",
  "block.minecraft.twisting_vines_plant": "Planta de lianas retorcidas",
  "block.minecraft.vault": "Bóveda",
  "block.minecraft.verdant_froglight": "Ranaluz verde",
  "block.minecraft.vine": "Lianas",
  "block.minecraft.void_air": "Aire del vacío",
  "block.minecraft.wall_torch": "Antorcha en pared",
  "block.minecraft.warped_button": "Botón distorsionado",
  "block.minecraft.warped_door": "Puerta distorsionada",
  "block.minecraft.warped_fence": "Cerca distorsionada",
  "block.minecraft.warped_fence_gate": "Puerta de cerca distorsionada",
  "block.minecraft.warped_fungus": "Champiñón distorsionado",
  "block.minecraft.warped_hanging_sign": "Letrero colgante distorsionado",
  "block.minecraft.warped_hyphae": "Hifas distorsionadas",
  "block.minecraft.warped_nylium": "Nilio distorsionado",
  "block.minecraft.warped_planks": "Tablas distorsionadas",
  "block.minecraft.warped_pressure_plate": "Placa de presión distorsionada",
  "block.minecraft.warped_roots": "Raíces distorsionadas",
  "block.minecraft.warped_shelf": "Estante distorsionado",
  "block.minecraft.warped_sign": "Letrero distorsionado",
  "block.minecraft.warped_slab": "Losa distorsionada",
  "block.minecraft.warped_stairs": "Escaleras distorsionadas",
  "block.minecraft.warped_stem": "Tallo distorsionado",
  "block.minecraft.warped_trapdoor": "Trampilla distorsionada",
  "block.minecraft.warped_wall_hanging_sign": "Letrero colgante distorsionado en pared",
  "block.minecraft.warped_wall_sign": "Letrero distorsionado en pared",
  "block.minecraft.warped_wart_block": "Bloque de verrugas distorsionadas",
  "block.minecraft.water": "Agua",
  "block.minecraft.water_cauldron": "Caldero con agua",
  "block.minecraft.waxed_chiseled_copper": "Cobre cincelado encerado",
  "block.minecraft.waxed_copper_bars": "Barras de cobre encerado",
  "block.minecraft.waxed_copper_block": "Bloque de cobre encerado",
  "block.minecraft.waxed_copper_bulb": "Lámpara de cobre encerado",
  "block.minecraft.waxed_copper_chain": "Cadena de cobre encerado",
  "block.minecraft.waxed_copper_chest": "Cofre de cobre encerado",
  "block.minecraft.waxed_copper_door": "Puerta de cobre encerado",
  "block.minecraft.waxed_copper_golem_statue": "Estatua de gólem de cobre encerado",
  "block.minecraft.waxed_copper_grate": "Rejilla de cobre encerado",
  "block.minecraft.waxed_copper_lantern": "Farol de cobre encerado",
  "block.minecraft.waxed_copper_trapdoor": "Trampilla de cobre encerado",
  "block.minecraft.waxed_cut_copper": "Cobre cortado encerado",
  "block.minecraft.waxed_cut_copper_slab": "Losa de cobre cortado encerado",
  "block.minecraft.waxed_cut_copper_stairs": "Escaleras de cobre cortado encerado",
  "block.minecraft.waxed_exposed_chiseled_copper": "Cobre cincelado expuesto encerado",
  "block.minecraft.waxed_exposed_copper": "Cobre encerado expuesto",
  "block.minecraft.waxed_exposed_copper_bars": "Barras de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_bulb": "Lámpara de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_chain": "Cadena de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_chest": "Cofre de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_door": "Puerta de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Estatua de gólem de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_grate": "Rejilla de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_lantern": "Farol de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Trampilla de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_cut_copper": "Cobre cortado encerado expuesto",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Losa de cobre cortado encerado expuesto",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Escaleras de cobre cortado encerado expuesto",
  "block.minecraft.waxed_exposed_lightning_rod": "Pararrayos expuesto encerado",
  "block.minecraft.waxed_lightning_rod": "Pararrayos encerado",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Cobre cincelado oxidado encerado",
  "block.minecraft.waxed_oxidized_copper": "Cobre encerado oxidado",
  "block.minecraft.waxed_oxidized_copper_bars": "Barras de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lámpara de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_chain": "Cadena de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_chest": "Cofre de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_door": "Puerta de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Estatua de gólem de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_grate": "Rejilla de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_lantern": "Farol de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Trampilla de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_cut_copper": "Cobre cortado encerado oxidado",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Losa de cobre cortado encerado oxidado",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Escaleras de cobre cortado encerado oxidado",
  "block.minecraft.waxed_oxidized_lightning_rod": "Pararrayos oxidado encerado",
  "block.minecraft.waxed_weathered_chiseled_copper": "Cobre cincelado degradado encerado",
  "block.minecraft.waxed_weathered_copper": "Cobre encerado degradado",
  "block.minecraft.waxed_weathered_copper_bars": "Barras de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_bulb": "Lámpara de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_chain": "Cadena de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_chest": "Cofre de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_door": "Puerta de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Estatua de gólem de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_grate": "Rejilla de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_lantern": "Farol de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Trampilla de cobre degradado encerado",
  "block.minecraft.waxed_weathered_cut_copper": "Cobre cortado encerado degradado",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Losa de cobre cortado encerado degradado",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Escaleras de cobre cortado encerado degradado",
  "block.minecraft.waxed_weathered_lightning_rod": "Pararrayos degradado encerado",
  "block.minecraft.weathered_chiseled_copper": "Cobre cincelado degradado",
  "block.minecraft.weathered_copper": "Cobre degradado",
  "block.minecraft.weathered_copper_bars": "Barras de cobre degradado",
  "block.minecraft.weathered_copper_bulb": "Lámpara de cobre degradado",
  "block.minecraft.weathered_copper_chain": "Cadena de cobre degradado",
  "block.minecraft.weathered_copper_chest": "Cofre de cobre degradado",
  "block.minecraft.weathered_copper_door": "Puerta de cobre degradado",
  "block.minecraft.weathered_copper_golem_statue": "Estatua de gólem de cobre degradado",
  "block.minecraft.weathered_copper_grate": "Rejilla de cobre degradado",
  "block.minecraft.weathered_copper_lantern": "Farol de cobre degradado",
  "block.minecraft.weathered_copper_trapdoor": "Trampilla de cobre degradado",
  "block.minecraft.weathered_cut_copper": "Cobre cortado degradado",
  "block.minecraft.weathered_cut_copper_slab": "Losa de cobre cortado degradado",
  "block.minecraft.weathered_cut_copper_stairs": "Escaleras de cobre cortado degradado",
  "block.minecraft.weathered_lightning_rod": "Pararrayos degradado",
  "block.minecraft.weeping_vines": "Lianas lloronas",
  "block.minecraft.weeping_vines_plant": "Planta de lianas lloronas",
  "block.minecraft.wet_sponge": "Esponja húmeda",
  "block.minecraft.wheat": "Cultivo de trigo",
  "block.minecraft.white_banner": "Estandarte blanco",
  "block.minecraft.white_bed": "Cama blanca",
  "block.minecraft.white_candle": "Vela blanca",
  "block.minecraft.white_candle_cake": "Pastel con vela blanca",
  "block.minecraft.white_carpet": "Alfombra blanca",
  "block.minecraft.white_concrete": "Concreto blanco",
  "block.minecraft.white_concrete_powder": "Cemento blanco",
  "block.minecraft.white_glazed_terracotta": "Azulejo blanco",
  "block.minecraft.white_shulker_box": "Caja de shulker blanca",
  "block.minecraft.white_stained_glass": "Vidrio blanco",
  "block.minecraft.white_stained_glass_pane": "Panel de vidrio blanco",
  "block.minecraft.white_terracotta": "Terracota blanca",
  "block.minecraft.white_tulip": "Tulipán blanco",
  "block.minecraft.white_wool": "Lana blanca",
  "block.minecraft.wildflowers": "Flores salvajes",
  "block.minecraft.wither_rose": "Rosa del Wither",
  "block.minecraft.wither_skeleton_skull": "Calavera de esqueleto del Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Calavera de esqueleto del Wither en pared",
  "block.minecraft.yellow_banner": "Estandarte amarillo",
  "block.minecraft.yellow_bed": "Cama amarilla",
  "block.minecraft.yellow_candle": "Vela amarilla",
  "block.minecraft.yellow_candle_cake": "Pastel con vela amarilla",
  "block.minecraft.yellow_carpet": "Alfombra amarilla",
  "block.minecraft.yellow_concrete": "Concreto amarillo",
  "block.minecraft.yellow_concrete_powder": "Cemento amarillo",
  "block.minecraft.yellow_glazed_terracotta": "Azulejo amarillo",
  "block.minecraft.yellow_shulker_box": "Caja de shulker amarilla",
  "block.minecraft.yellow_stained_glass": "Vidrio amarillo",
  "block.minecraft.yellow_stained_glass_pane": "Panel de vidrio amarillo",
  "block.minecraft.yellow_terracotta": "Terracota amarilla",
  "block.minecraft.yellow_wool": "Lana amarilla",
  "block.minecraft.zombie_head": "Cabeza de zombi",
  "block.minecraft.zombie_wall_head": "Cabeza de zombi en pared",
  "item.minecraft.acacia_boat": "Bote de acacia",
  "item.minecraft.acacia_chest_boat": "Bote de acacia con cofre",
  "item.minecraft.allay_spawn_egg": "Generar allay",
  "item.minecraft.amethyst_shard": "Fragmento de amatista",
  "item.minecraft.angler_pottery_shard": "Fragmento de cerámica de pesca",
  "item.minecraft.angler_pottery_sherd": "Fragmento de cerámica de caña de pescar",
  "item.minecraft.apple": "Manzana",
  "item.minecraft.archer_pottery_shard": "Fragmento de cerámica de arquero",
  "item.minecraft.archer_pottery_sherd": "Fragmento de cerámica de arquero",
  "item.minecraft.armadillo_scute": "Escama de armadillo",
  "item.minecraft.armadillo_spawn_egg": "Generar armadillo",
  "item.minecraft.armor_stand": "Soporte para armadura",
  "item.minecraft.arms_up_pottery_shard": "Fragmento de cerámica de persona",
  "item.minecraft.arms_up_pottery_sherd": "Fragmento de cerámica de persona",
  "item.minecraft.arrow": "Flecha",
  "item.minecraft.axolotl_bucket": "Cubeta con ajolote",
  "item.minecraft.axolotl_spawn_egg": "Generar ajolote",
  "item.minecraft.baked_potato": "Papa asada",
  "item.minecraft.bamboo_chest_raft": "Balsa de bambú con cofre",
  "item.minecraft.bamboo_raft": "Balsa de bambú",
  "item.minecraft.bat_spawn_egg": "Generar murciélago",
  "item.minecraft.bee_spawn_egg": "Generar abeja",
  "item.minecraft.beef": "Filete crudo",
  "item.minecraft.beetroot": "Remolacha",
  "item.minecraft.beetroot_seeds": "Semillas de remolacha",
  "item.minecraft.beetroot_soup": "Estofado de remolacha",
  "item.minecraft.birch_boat": "Bote de abedul",
  "item.minecraft.birch_chest_boat": "Bote de abedul con cofre",
  "item.minecraft.black_bundle": "Saco negro",
  "item.minecraft.black_dye": "Tinte negro",
  "item.minecraft.black_harness": "Arnés negro",
  "item.minecraft.blade_pottery_shard": "Fragmento de cerámica de espada",
  "item.minecraft.blade_pottery_sherd": "Fragmento de cerámica de espada",
  "item.minecraft.blaze_powder": "Polvo de blaze",
  "item.minecraft.blaze_rod": "Vara de blaze",
  "item.minecraft.blaze_spawn_egg": "Generar blaze",
  "item.minecraft.blue_bundle": "Saco azul",
  "item.minecraft.blue_dye": "Tinte azul",
  "item.minecraft.blue_egg": "Huevo azul",
  "item.minecraft.blue_harness": "Arnés azul",
  "item.minecraft.bogged_spawn_egg": "Generar ciénago",
  "item.minecraft.bolt_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Diseño de armadura de remaches",
  "item.minecraft.bone": "Hueso",
  "item.minecraft.bone_meal": "Polvo de hueso",
  "item.minecraft.book": "Libro",
  "item.minecraft.bordure_indented_banner_pattern": "Bordura dentada",
  "item.minecraft.bow": "Arco",
  "item.minecraft.bowl": "Tazón",
  "item.minecraft.bread": "Pan",
  "item.minecraft.breeze_rod": "Vara de breeze",
  "item.minecraft.breeze_spawn_egg": "Generar breeze",
  "item.minecraft.brewer_pottery_shard": "Fragmento de cerámica de poción",
  "item.minecraft.brewer_pottery_sherd": "Fragmento de cerámica de poción",
  "item.minecraft.brewing_stand": "Soporte para pociones",
  "item.minecraft.brick": "Ladrillo",
  "item.minecraft.brown_bundle": "Saco café",
  "item.minecraft.brown_dye": "Tinte café",
  "item.minecraft.brown_egg": "Huevo café",
  "item.minecraft.brown_harness": "Arnés marrón",
  "item.minecraft.brush": "Cepillo",
  "item.minecraft.bucket": "Cubeta",
  "item.minecraft.bundle": "Bolsa",
  "item.minecraft.bundle.empty": "Vacío",
  "item.minecraft.bundle.empty.description": "Puede almacenar varios objetos",
  "item.minecraft.bundle.full": "Lleno",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Fragmento de cerámica de fuego",
  "item.minecraft.burn_pottery_sherd": "Fragmento de cerámica de fuego",
  "item.minecraft.camel_husk_spawn_egg": "Generar camello momificado",
  "item.minecraft.camel_spawn_egg": "Generar camello",
  "item.minecraft.carrot": "Zanahoria",
  "item.minecraft.carrot_on_a_stick": "Caña con zanahoria",
  "item.minecraft.cat_spawn_egg": "Generar gato",
  "item.minecraft.cauldron": "Caldero",
  "item.minecraft.cave_spider_spawn_egg": "Generar araña de cueva",
  "item.minecraft.chainmail_boots": "Botas de cota de malla",
  "item.minecraft.chainmail_chestplate": "Pechera de cota de malla",
  "item.minecraft.chainmail_helmet": "Yelmo de cota de malla",
  "item.minecraft.chainmail_leggings": "Grebas de cota de malla",
  "item.minecraft.charcoal": "Carbón vegetal",
  "item.minecraft.cherry_boat": "Bote de cerezo",
  "item.minecraft.cherry_chest_boat": "Bote de cerezo con cofre",
  "item.minecraft.chest_minecart": "Vagón con cofre",
  "item.minecraft.chicken": "Pollo crudo",
  "item.minecraft.chicken_spawn_egg": "Generar gallina",
  "item.minecraft.chorus_fruit": "Fruta de chorus",
  "item.minecraft.clay_ball": "Bola de arcilla",
  "item.minecraft.clock": "Reloj",
  "item.minecraft.coal": "Carbón",
  "item.minecraft.coast_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Diseño de costa",
  "item.minecraft.cocoa_beans": "Granos de cacao",
  "item.minecraft.cod": "Bacalao crudo",
  "item.minecraft.cod_bucket": "Cubeta con bacalao",
  "item.minecraft.cod_spawn_egg": "Generar bacalao",
  "item.minecraft.command_block_minecart": "Vagón con bloque de comandos",
  "item.minecraft.compass": "Brújula",
  "item.minecraft.cooked_beef": "Filete asado",
  "item.minecraft.cooked_chicken": "Pollo asado",
  "item.minecraft.cooked_cod": "Bacalao asado",
  "item.minecraft.cooked_mutton": "Cordero asado",
  "item.minecraft.cooked_porkchop": "Chuleta asada",
  "item.minecraft.cooked_rabbit": "Conejo asado",
  "item.minecraft.cooked_salmon": "Salmón asado",
  "item.minecraft.cookie": "Galleta",
  "item.minecraft.copper_axe": "Hacha de cobre",
  "item.minecraft.copper_boots": "Botas de cobre",
  "item.minecraft.copper_chestplate": "Pechera de cobre",
  "item.minecraft.copper_golem_spawn_egg": "Generar gólem de cobre",
  "item.minecraft.copper_helmet": "Casco de cobre",
  "item.minecraft.copper_hoe": "Azada de cobre",
  "item.minecraft.copper_horse_armor": "Armadura de cobre para caballo",
  "item.minecraft.copper_ingot": "Lingote de cobre",
  "item.minecraft.copper_leggings": "Pantalones de cobre",
  "item.minecraft.copper_nautilus_armor": "Armadura de cobre para nautilo",
  "item.minecraft.copper_nugget": "Pepita de cobre",
  "item.minecraft.copper_pickaxe": "Pico de cobre",
  "item.minecraft.copper_shovel": "Pala de cobre",
  "item.minecraft.copper_spear": "Lanza de cobre",
  "item.minecraft.copper_sword": "Espada de cobre",
  "item.minecraft.cow_spawn_egg": "Generar vaca",
  "item.minecraft.creaking_spawn_egg": "Generar crepitante",
  "item.minecraft.creeper_banner_pattern": "Diseño de estandarte",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Estampado de Creeper",
  "item.minecraft.creeper_spawn_egg": "Generar creeper",
  "item.minecraft.crossbow": "Ballesta",
  "item.minecraft.crossbow.projectile": "Proyectil:",
  "item.minecraft.crossbow.projectile.multiple": "Proyectil: %sx%s",
  "item.minecraft.crossbow.projectile.single": "Proyectil: %s",
  "item.minecraft.cyan_bundle": "Saco turquesa",
  "item.minecraft.cyan_dye": "Tinte turquesa",
  "item.minecraft.cyan_harness": "Arnés cian",
  "item.minecraft.danger_pottery_shard": "Fragmento de cerámica de peligro",
  "item.minecraft.danger_pottery_sherd": "Fragmento de cerámica de peligro",
  "item.minecraft.dark_oak_boat": "Bote de roble oscuro",
  "item.minecraft.dark_oak_chest_boat": "Bote de roble oscuro con cofre",
  "item.minecraft.debug_stick": "Palo de desarrollo",
  "item.minecraft.debug_stick.empty": "%s no tiene propiedades",
  "item.minecraft.debug_stick.select": "seleccionado «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s» a %s",
  "item.minecraft.diamond": "Diamante",
  "item.minecraft.diamond_axe": "Hacha de diamante",
  "item.minecraft.diamond_boots": "Botas de diamante",
  "item.minecraft.diamond_chestplate": "Pechera de diamante",
  "item.minecraft.diamond_helmet": "Yelmo de diamante",
  "item.minecraft.diamond_hoe": "Azada de diamante",
  "item.minecraft.diamond_horse_armor": "Armadura de diamante para caballo",
  "item.minecraft.diamond_leggings": "Grebas de diamante",
  "item.minecraft.diamond_nautilus_armor": "Armadura de diamante para nautilo",
  "item.minecraft.diamond_pickaxe": "Pico de diamante",
  "item.minecraft.diamond_shovel": "Pala de diamante",
  "item.minecraft.diamond_spear": "Lanza de diamante",
  "item.minecraft.diamond_sword": "Espada de diamante",
  "item.minecraft.disc_fragment_5": "Fragmento de disco",
  "item.minecraft.disc_fragment_5.desc": "Disco - 5",
  "item.minecraft.dolphin_spawn_egg": "Generar delfín",
  "item.minecraft.donkey_spawn_egg": "Generar burro",
  "item.minecraft.dragon_breath": "Aliento de dragón",
  "item.minecraft.dried_kelp": "Algas secas",
  "item.minecraft.drowned_spawn_egg": "Generar ahogado",
  "item.minecraft.dune_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Diseño de armadura de las dunas",
  "item.minecraft.echo_shard": "Fragmento de eco",
  "item.minecraft.egg": "Huevo",
  "item.minecraft.elder_guardian_spawn_egg": "Generar guardián anciano",
  "item.minecraft.elytra": "Élitros",
  "item.minecraft.emerald": "Esmeralda",
  "item.minecraft.enchanted_book": "Libro encantado",
  "item.minecraft.enchanted_golden_apple": "Manzana dorada encantada",
  "item.minecraft.end_crystal": "Cristal del End",
  "item.minecraft.ender_dragon_spawn_egg": "Generar Enderdragón",
  "item.minecraft.ender_eye": "Ojo de ender",
  "item.minecraft.ender_pearl": "Perla de ender",
  "item.minecraft.enderman_spawn_egg": "Generar enderman",
  "item.minecraft.endermite_spawn_egg": "Generar endermite",
  "item.minecraft.evoker_spawn_egg": "Generar evocador",
  "item.minecraft.experience_bottle": "Botella de experiencia",
  "item.minecraft.explorer_pottery_shard": "Fragmento de cerámica de explorador",
  "item.minecraft.explorer_pottery_sherd": "Fragmento de cerámica de explorador",
  "item.minecraft.eye_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Diseño de armadura de ojos",
  "item.minecraft.feather": "Pluma",
  "item.minecraft.fermented_spider_eye": "Ojo de araña fermentado",
  "item.minecraft.field_masoned_banner_pattern": "Estampado de mazonado",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Carga ígnea",
  "item.minecraft.firework_rocket": "Cohete de fuegos artificiales",
  "item.minecraft.firework_rocket.flight": "Duración del vuelo:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Pólvora de fuegos artificiales",
  "item.minecraft.firework_star.black": "negra",
  "item.minecraft.firework_star.blue": "azul",
  "item.minecraft.firework_star.brown": "café",
  "item.minecraft.firework_star.custom_color": "Personalizado",
  "item.minecraft.firework_star.cyan": "turquesa",
  "item.minecraft.firework_star.fade_to": "Se vuelve",
  "item.minecraft.firework_star.flicker": " con destellos.",
  "item.minecraft.firework_star.gray": "gris",
  "item.minecraft.firework_star.green": "verde",
  "item.minecraft.firework_star.light_blue": "celeste",
  "item.minecraft.firework_star.light_gray": "gris claro",
  "item.minecraft.firework_star.lime": "verde lima",
  "item.minecraft.firework_star.magenta": "fucsia",
  "item.minecraft.firework_star.orange": "naranja",
  "item.minecraft.firework_star.pink": "rosada",
  "item.minecraft.firework_star.purple": "morada",
  "item.minecraft.firework_star.red": "roja",
  "item.minecraft.firework_star.shape": "Forma desconocida",
  "item.minecraft.firework_star.shape.burst": "Explosión",
  "item.minecraft.firework_star.shape.creeper": "Con forma de creeper",
  "item.minecraft.firework_star.shape.large_ball": "Esfera grande",
  "item.minecraft.firework_star.shape.small_ball": "Esfera pequeña",
  "item.minecraft.firework_star.shape.star": "Con forma de estrella",
  "item.minecraft.firework_star.trail": " con estela.",
  "item.minecraft.firework_star.white": "blanca",
  "item.minecraft.firework_star.yellow": "amarilla",
  "item.minecraft.fishing_rod": "Caña de pescar",
  "item.minecraft.flint": "Pedernal",
  "item.minecraft.flint_and_steel": "Encendedor",
  "item.minecraft.flow_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Diseño de armadura de espiral",
  "item.minecraft.flow_banner_pattern": "Diseño de estandarte",
  "item.minecraft.flow_banner_pattern.desc": "Espiral",
  "item.minecraft.flow_banner_pattern.new": "Estampado de espiral",
  "item.minecraft.flow_pottery_sherd": "Fragmento de cerámica de espiral",
  "item.minecraft.flower_banner_pattern": "Diseño de estandarte",
  "item.minecraft.flower_banner_pattern.desc": "Flor",
  "item.minecraft.flower_banner_pattern.new": "Estampado de flor",
  "item.minecraft.flower_pot": "Maceta",
  "item.minecraft.fox_spawn_egg": "Generar zorro",
  "item.minecraft.friend_pottery_shard": "Fragmento de cerámica de amistad",
  "item.minecraft.friend_pottery_sherd": "Fragmento de cerámica de amistad",
  "item.minecraft.frog_spawn_egg": "Generar rana",
  "item.minecraft.furnace_minecart": "Vagón con horno",
  "item.minecraft.ghast_spawn_egg": "Generar ghast",
  "item.minecraft.ghast_tear": "Lágrima de ghast",
  "item.minecraft.glass_bottle": "Botella",
  "item.minecraft.glistering_melon_slice": "Rebanada de sandía brillante",
  "item.minecraft.globe_banner_pattern": "Diseño de estandarte",
  "item.minecraft.globe_banner_pattern.desc": "Planeta",
  "item.minecraft.globe_banner_pattern.new": "Estampado de planeta",
  "item.minecraft.glow_berries": "Frutos luminosos",
  "item.minecraft.glow_ink_sac": "Saco de tinta luminosa",
  "item.minecraft.glow_item_frame": "Marco luminoso",
  "item.minecraft.glow_squid_spawn_egg": "Generar calamar luminoso",
  "item.minecraft.glowstone_dust": "Polvo de piedra luminosa",
  "item.minecraft.goat_horn": "Cuerno de cabra",
  "item.minecraft.goat_spawn_egg": "Generar cabra",
  "item.minecraft.gold_ingot": "Lingote de oro",
  "item.minecraft.gold_nugget": "Pepita de oro",
  "item.minecraft.golden_apple": "Manzana dorada",
  "item.minecraft.golden_axe": "Hacha de oro",
  "item.minecraft.golden_boots": "Botas de oro",
  "item.minecraft.golden_carrot": "Zanahoria dorada",
  "item.minecraft.golden_chestplate": "Pechera de oro",
  "item.minecraft.golden_helmet": "Yelmo de oro",
  "item.minecraft.golden_hoe": "Azada de oro",
  "item.minecraft.golden_horse_armor": "Armadura de oro para caballo",
  "item.minecraft.golden_leggings": "Grebas de oro",
  "item.minecraft.golden_nautilus_armor": "Armadura de oro para nautilo",
  "item.minecraft.golden_pickaxe": "Pico de oro",
  "item.minecraft.golden_shovel": "Pala de oro",
  "item.minecraft.golden_spear": "Lanza de oro",
  "item.minecraft.golden_sword": "Espada de oro",
  "item.minecraft.gray_bundle": "Saco gris",
  "item.minecraft.gray_dye": "Tinte gris",
  "item.minecraft.gray_harness": "Arnés gris",
  "item.minecraft.green_bundle": "Saco verde",
  "item.minecraft.green_dye": "Tinte verde",
  "item.minecraft.green_harness": "Arnés verde",
  "item.minecraft.guardian_spawn_egg": "Generar guardián",
  "item.minecraft.gunpowder": "Pólvora",
  "item.minecraft.guster_banner_pattern": "Diseño de estandarte",
  "item.minecraft.guster_banner_pattern.desc": "Torbellino",
  "item.minecraft.guster_banner_pattern.new": "Estampado de torbellino",
  "item.minecraft.guster_pottery_sherd": "Fragmento de cerámica de breeze",
  "item.minecraft.happy_ghast_spawn_egg": "Generar ghast feliz",
  "item.minecraft.harness": "Arnés",
  "item.minecraft.heart_of_the_sea": "Corazón del mar",
  "item.minecraft.heart_pottery_shard": "Fragmento de cerámica de corazón",
  "item.minecraft.heart_pottery_sherd": "Fragmento de cerámica de corazón",
  "item.minecraft.heartbreak_pottery_shard": "Fragmento de cerámica de corazón roto",
  "item.minecraft.heartbreak_pottery_sherd": "Fragmento de cerámica de corazón roto",
  "item.minecraft.hoglin_spawn_egg": "Generar hoglin",
  "item.minecraft.honey_bottle": "Botella de miel",
  "item.minecraft.honeycomb": "Panal",
  "item.minecraft.hopper_minecart": "Vagón con tolva",
  "item.minecraft.horse_spawn_egg": "Generar caballo",
  "item.minecraft.host_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.host_armor_trim_smithing_template.new": "Diseño de armadura de anfitrión",
  "item.minecraft.howl_pottery_shard": "Fragmento de cerámica de canino",
  "item.minecraft.howl_pottery_sherd": "Fragmento de cerámica de canino",
  "item.minecraft.husk_spawn_egg": "Generar zombi momificado",
  "item.minecraft.ink_sac": "Saco de tinta",
  "item.minecraft.iron_axe": "Hacha de hierro",
  "item.minecraft.iron_boots": "Botas de hierro",
  "item.minecraft.iron_chestplate": "Pechera de hierro",
  "item.minecraft.iron_golem_spawn_egg": "Generar gólem de hierro",
  "item.minecraft.iron_helmet": "Yelmo de hierro",
  "item.minecraft.iron_hoe": "Azada de hierro",
  "item.minecraft.iron_horse_armor": "Armadura de hierro para caballo",
  "item.minecraft.iron_ingot": "Lingote de hierro",
  "item.minecraft.iron_leggings": "Grebas de hierro",
  "item.minecraft.iron_nautilus_armor": "Armadura de hierro para nautilo",
  "item.minecraft.iron_nugget": "Pepita de hierro",
  "item.minecraft.iron_pickaxe": "Pico de hierro",
  "item.minecraft.iron_shovel": "Pala de hierro",
  "item.minecraft.iron_spear": "Lanza de hierro",
  "item.minecraft.iron_sword": "Espada de hierro",
  "item.minecraft.item_frame": "Marco",
  "item.minecraft.jungle_boat": "Bote de jungla",
  "item.minecraft.jungle_chest_boat": "Bote de jungla con cofre",
  "item.minecraft.knowledge_book": "Enciclopedia",
  "item.minecraft.lapis_lazuli": "Lapislázuli",
  "item.minecraft.lava_bucket": "Cubeta de lava",
  "item.minecraft.lead": "Rienda",
  "item.minecraft.leather": "Cuero",
  "item.minecraft.leather_boots": "Botas de cuero",
  "item.minecraft.leather_chestplate": "Túnica de cuero",
  "item.minecraft.leather_helmet": "Gorra de cuero",
  "item.minecraft.leather_horse_armor": "Armadura de cuero para caballo",
  "item.minecraft.leather_leggings": "Pantalones de cuero",
  "item.minecraft.light_blue_bundle": "Saco celeste",
  "item.minecraft.light_blue_dye": "Tinte celeste",
  "item.minecraft.light_blue_harness": "Arnés azul claro",
  "item.minecraft.light_gray_bundle": "Saco gris claro",
  "item.minecraft.light_gray_dye": "Tinte gris claro",
  "item.minecraft.light_gray_harness": "Arnés gris claro",
  "item.minecraft.lime_bundle": "Saco verde lima",
  "item.minecraft.lime_dye": "Tinte verde lima",
  "item.minecraft.lime_harness": "Arnés verde lima",
  "item.minecraft.lingering_potion": "Poción persistente",
  "item.minecraft.lingering_potion.effect.awkward": "Poción extraña persistente",
  "item.minecraft.lingering_potion.effect.empty": "Poción persistente no fabricable",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Poción de resistencia al fuego persistente",
  "item.minecraft.lingering_potion.effect.harming": "Poción de daño persistente",
  "item.minecraft.lingering_potion.effect.healing": "Poción de curación persistente",
  "item.minecraft.lingering_potion.effect.infested": "Poción de infestación persistente",
  "item.minecraft.lingering_potion.effect.invisibility": "Poción de invisibilidad persistente",
  "item.minecraft.lingering_potion.effect.leaping": "Poción de salto persistente",
  "item.minecraft.lingering_potion.effect.levitation": "Poción de levitación persistente",
  "item.minecraft.lingering_potion.effect.luck": "Poción de la suerte persistente",
  "item.minecraft.lingering_potion.effect.mundane": "Poción mundana persistente",
  "item.minecraft.lingering_potion.effect.night_vision": "Poción de visión nocturna persistente",
  "item.minecraft.lingering_potion.effect.oozing": "Poción de mucosidad persistente",
  "item.minecraft.lingering_potion.effect.poison": "Poción de veneno persistente",
  "item.minecraft.lingering_potion.effect.regeneration": "Poción de regeneración persistente",
  "item.minecraft.lingering_potion.effect.slow_falling": "Poción de caída lenta persistente",
  "item.minecraft.lingering_potion.effect.slowness": "Poción de lentitud persistente",
  "item.minecraft.lingering_potion.effect.strength": "Poción de fuerza persistente",
  "item.minecraft.lingering_potion.effect.swiftness": "Poción de velocidad persistente",
  "item.minecraft.lingering_potion.effect.thick": "Poción espesa persistente",
  "item.minecraft.lingering_potion.effect.turtle_master": "Poción del maestro tortuga persistente",
  "item.minecraft.lingering_potion.effect.water": "Botella de agua persistente",
  "item.minecraft.lingering_potion.effect.water_breathing": "Poción de respiración acuática persistente",
  "item.minecraft.lingering_potion.effect.weakness": "Poción de debilidad persistente",
  "item.minecraft.lingering_potion.effect.weaving": "Poción de tejedura persistente",
  "item.minecraft.lingering_potion.effect.wind_charged": "Poción de ráfaga persistente",
  "item.minecraft.llama_spawn_egg": "Generar llama",
  "item.minecraft.lodestone_compass": "Brújula magnetizada",
  "item.minecraft.mace": "Mazo",
  "item.minecraft.magenta_bundle": "Saco fucsia",
  "item.minecraft.magenta_dye": "Tinte fucsia",
  "item.minecraft.magenta_harness": "Arnés magenta",
  "item.minecraft.magma_cream": "Crema de magma",
  "item.minecraft.magma_cube_spawn_egg": "Generar cubo de magma",
  "item.minecraft.mangrove_boat": "Bote de mangle",
  "item.minecraft.mangrove_chest_boat": "Bote de mangle con cofre",
  "item.minecraft.map": "Mapa en blanco",
  "item.minecraft.melon_seeds": "Semillas de sandía",
  "item.minecraft.melon_slice": "Rebanada de sandía",
  "item.minecraft.milk_bucket": "Cubeta de leche",
  "item.minecraft.minecart": "Vagón",
  "item.minecraft.miner_pottery_shard": "Fragmento de cerámica de minero",
  "item.minecraft.miner_pottery_sherd": "Fragmento de cerámica de minero",
  "item.minecraft.mojang_banner_pattern": "Diseño de estandarte",
  "item.minecraft.mojang_banner_pattern.desc": "Cosa",
  "item.minecraft.mojang_banner_pattern.new": "Estampado de cosa",
  "item.minecraft.mooshroom_spawn_egg": "Generar mooshroom",
  "item.minecraft.mourner_pottery_shard": "Fragmento de cerámica de doliente",
  "item.minecraft.mourner_pottery_sherd": "Fragmento de cerámica de doliente",
  "item.minecraft.mule_spawn_egg": "Generar mula",
  "item.minecraft.mushroom_stew": "Estofado de champiñones",
  "item.minecraft.music_disc_11": "Disco",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disco",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disco",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disco",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disco",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disco",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disco",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disco",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creador (Caja Musical)",
  "item.minecraft.music_disc_far": "Disco",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disco",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disco",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disco",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disco",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disco",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disco",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disco de música",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disco",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disco",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disco",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disco",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disco",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Cordero crudo",
  "item.minecraft.name_tag": "Etiqueta",
  "item.minecraft.nautilus_shell": "Caparazón de nautilo",
  "item.minecraft.nautilus_spawn_egg": "Generar nautilo",
  "item.minecraft.nether_brick": "Ladrillo del Nether",
  "item.minecraft.nether_star": "Estrella del Nether",
  "item.minecraft.nether_wart": "Verruga del Nether",
  "item.minecraft.netherite_axe": "Hacha de netherita",
  "item.minecraft.netherite_boots": "Botas de netherita",
  "item.minecraft.netherite_chestplate": "Pechera de netherita",
  "item.minecraft.netherite_helmet": "Yelmo de netherita",
  "item.minecraft.netherite_hoe": "Azada de netherita",
  "item.minecraft.netherite_horse_armor": "Armadura de netherita para caballo",
  "item.minecraft.netherite_ingot": "Lingote de netherita",
  "item.minecraft.netherite_leggings": "Grebas de netherita",
  "item.minecraft.netherite_nautilus_armor": "Armadura de netherita para nautilo",
  "item.minecraft.netherite_pickaxe": "Pico de netherita",
  "item.minecraft.netherite_scrap": "Fragmento de netherita",
  "item.minecraft.netherite_shovel": "Pala de netherita",
  "item.minecraft.netherite_spear": "Lanza de netherita",
  "item.minecraft.netherite_sword": "Espada de netherita",
  "item.minecraft.netherite_upgrade_smithing_template": "Molde de herrería",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Mejora de netherita",
  "item.minecraft.oak_boat": "Bote de roble",
  "item.minecraft.oak_chest_boat": "Bote de roble con cofre",
  "item.minecraft.ocelot_spawn_egg": "Generar ocelote",
  "item.minecraft.ominous_bottle": "Botella ominosa",
  "item.minecraft.ominous_trial_key": "Llave de desafío ominosa",
  "item.minecraft.orange_bundle": "Saco naranja",
  "item.minecraft.orange_dye": "Tinte naranja",
  "item.minecraft.orange_harness": "Arnés naranja",
  "item.minecraft.painting": "Cuadro",
  "item.minecraft.pale_oak_boat": "Bote de roble pálido",
  "item.minecraft.pale_oak_chest_boat": "Bote de roble pálido con cofre",
  "item.minecraft.panda_spawn_egg": "Generar panda",
  "item.minecraft.paper": "Papel",
  "item.minecraft.parched_spawn_egg": "Generar esqueleto momificado",
  "item.minecraft.parrot_spawn_egg": "Generar loro",
  "item.minecraft.phantom_membrane": "Membrana de fantasma",
  "item.minecraft.phantom_spawn_egg": "Generar fantasma",
  "item.minecraft.pig_spawn_egg": "Generar cerdo",
  "item.minecraft.piglin_banner_pattern": "Diseño de estandarte",
  "item.minecraft.piglin_banner_pattern.desc": "Hocico",
  "item.minecraft.piglin_banner_pattern.new": "Estampado de hocico",
  "item.minecraft.piglin_brute_spawn_egg": "Generar piglin bruto",
  "item.minecraft.piglin_spawn_egg": "Generar piglin",
  "item.minecraft.pillager_spawn_egg": "Generar saqueador",
  "item.minecraft.pink_bundle": "Saco rosado",
  "item.minecraft.pink_dye": "Tinte rosado",
  "item.minecraft.pink_harness": "Arnés rosa",
  "item.minecraft.pitcher_plant": "Planta odre",
  "item.minecraft.pitcher_pod": "Vaina de odre",
  "item.minecraft.plenty_pottery_shard": "Fragmento de cerámica de abundancia",
  "item.minecraft.plenty_pottery_sherd": "Fragmento de cerámica de abundancia",
  "item.minecraft.poisonous_potato": "Papa venenosa",
  "item.minecraft.polar_bear_spawn_egg": "Generar oso polar",
  "item.minecraft.popped_chorus_fruit": "Fruta de chorus asada",
  "item.minecraft.porkchop": "Chuleta cruda",
  "item.minecraft.potato": "Papa",
  "item.minecraft.potion": "Poción",
  "item.minecraft.potion.effect.awkward": "Poción extraña",
  "item.minecraft.potion.effect.empty": "Poción no fabricable",
  "item.minecraft.potion.effect.fire_resistance": "Poción de resistencia al fuego",
  "item.minecraft.potion.effect.harming": "Poción de daño",
  "item.minecraft.potion.effect.healing": "Poción de curación",
  "item.minecraft.potion.effect.infested": "Poción de infestación",
  "item.minecraft.potion.effect.invisibility": "Poción de invisibilidad",
  "item.minecraft.potion.effect.leaping": "Poción de salto",
  "item.minecraft.potion.effect.levitation": "Poción de levitación",
  "item.minecraft.potion.effect.luck": "Poción de la suerte",
  "item.minecraft.potion.effect.mundane": "Poción mundana",
  "item.minecraft.potion.effect.night_vision": "Poción de visión nocturna",
  "item.minecraft.potion.effect.oozing": "Poción de mucosidad",
  "item.minecraft.potion.effect.poison": "Poción de veneno",
  "item.minecraft.potion.effect.regeneration": "Poción de regeneración",
  "item.minecraft.potion.effect.slow_falling": "Poción de caída lenta",
  "item.minecraft.potion.effect.slowness": "Poción de lentitud",
  "item.minecraft.potion.effect.strength": "Poción de fuerza",
  "item.minecraft.potion.effect.swiftness": "Poción de velocidad",
  "item.minecraft.potion.effect.thick": "Poción espesa",
  "item.minecraft.potion.effect.turtle_master": "Poción del maestro tortuga",
  "item.minecraft.potion.effect.water": "Botella de agua",
  "item.minecraft.potion.effect.water_breathing": "Poción de respiración acuática",
  "item.minecraft.potion.effect.weakness": "Poción de debilidad",
  "item.minecraft.potion.effect.weaving": "Poción de tejedura",
  "item.minecraft.potion.effect.wind_charged": "Poción de ráfaga",
  "item.minecraft.pottery_shard_archer": "Fragmento de cerámica de arquero",
  "item.minecraft.pottery_shard_arms_up": "Fragmento de cerámica de persona",
  "item.minecraft.pottery_shard_prize": "Fragmento de cerámica de tesoro",
  "item.minecraft.pottery_shard_skull": "Fragmento de cerámica de calavera",
  "item.minecraft.powder_snow_bucket": "Cubeta de nieve polvo",
  "item.minecraft.prismarine_crystals": "Cristales de prismarina",
  "item.minecraft.prismarine_shard": "Fragmento de prismarina",
  "item.minecraft.prize_pottery_shard": "Fragmento de cerámica de tesoro",
  "item.minecraft.prize_pottery_sherd": "Fragmento de cerámica de tesoro",
  "item.minecraft.pufferfish": "Pez globo",
  "item.minecraft.pufferfish_bucket": "Cubeta con pez globo",
  "item.minecraft.pufferfish_spawn_egg": "Generar pez globo",
  "item.minecraft.pumpkin_pie": "Pastel de calabaza",
  "item.minecraft.pumpkin_seeds": "Semillas de calabaza",
  "item.minecraft.purple_bundle": "Saco morado",
  "item.minecraft.purple_dye": "Tinte morado",
  "item.minecraft.purple_harness": "Arnés morado",
  "item.minecraft.quartz": "Cuarzo del Nether",
  "item.minecraft.rabbit": "Conejo crudo",
  "item.minecraft.rabbit_foot": "Pata de conejo",
  "item.minecraft.rabbit_hide": "Piel de conejo",
  "item.minecraft.rabbit_spawn_egg": "Generar conejo",
  "item.minecraft.rabbit_stew": "Estofado de conejo",
  "item.minecraft.raiser_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Diseño de armadura de elevación",
  "item.minecraft.ravager_spawn_egg": "Generar devastador",
  "item.minecraft.raw_copper": "Cobre en bruto",
  "item.minecraft.raw_gold": "Oro en bruto",
  "item.minecraft.raw_iron": "Hierro en bruto",
  "item.minecraft.recovery_compass": "Brújula de recuperación",
  "item.minecraft.red_bundle": "Saco rojo",
  "item.minecraft.red_dye": "Tinte rojo",
  "item.minecraft.red_harness": "Arnés rojo",
  "item.minecraft.redstone": "Polvo de redstone",
  "item.minecraft.resin_brick": "Ladrillo de resina",
  "item.minecraft.resin_clump": "Resina",
  "item.minecraft.rib_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Diseño de armadura de costillas",
  "item.minecraft.rotten_flesh": "Carne podrida",
  "item.minecraft.saddle": "Silla de montar",
  "item.minecraft.salmon": "Salmón crudo",
  "item.minecraft.salmon_bucket": "Cubeta con salmón",
  "item.minecraft.salmon_spawn_egg": "Generar salmón",
  "item.minecraft.scrape_pottery_sherd": "Fragmento de cerámica de hacha",
  "item.minecraft.scute": "Escama",
  "item.minecraft.sentry_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Diseño de armadura de centinela",
  "item.minecraft.shaper_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Diseño de armadura de modelador",
  "item.minecraft.sheaf_pottery_shard": "Fragmento de cerámica de trigo",
  "item.minecraft.sheaf_pottery_sherd": "Fragmento de cerámica de trigo",
  "item.minecraft.shears": "Tijeras",
  "item.minecraft.sheep_spawn_egg": "Generar oveja",
  "item.minecraft.shelter_pottery_shard": "Fragmento de cerámica de refugio",
  "item.minecraft.shelter_pottery_sherd": "Fragmento de cerámica de refugio",
  "item.minecraft.shield": "Escudo",
  "item.minecraft.shield.black": "Escudo negro",
  "item.minecraft.shield.blue": "Escudo azul",
  "item.minecraft.shield.brown": "Escudo café",
  "item.minecraft.shield.cyan": "Escudo turquesa",
  "item.minecraft.shield.gray": "Escudo gris",
  "item.minecraft.shield.green": "Escudo verde",
  "item.minecraft.shield.light_blue": "Escudo celeste",
  "item.minecraft.shield.light_gray": "Escudo gris claro",
  "item.minecraft.shield.lime": "Escudo verde lima",
  "item.minecraft.shield.magenta": "Escudo fucsia",
  "item.minecraft.shield.orange": "Escudo naranja",
  "item.minecraft.shield.pink": "Escudo rosado",
  "item.minecraft.shield.purple": "Escudo morado",
  "item.minecraft.shield.red": "Escudo rojo",
  "item.minecraft.shield.white": "Escudo blanco",
  "item.minecraft.shield.yellow": "Escudo amarillo",
  "item.minecraft.shulker_shell": "Caparazón de shulker",
  "item.minecraft.shulker_spawn_egg": "Generar shulker",
  "item.minecraft.sign": "Letrero",
  "item.minecraft.silence_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Diseño de armadura de silencio",
  "item.minecraft.silverfish_spawn_egg": "Generar lepisma",
  "item.minecraft.skeleton_horse_spawn_egg": "Generar caballo esquelético",
  "item.minecraft.skeleton_spawn_egg": "Generar esqueleto",
  "item.minecraft.skull_banner_pattern": "Diseño de estandarte",
  "item.minecraft.skull_banner_pattern.desc": "Calavera",
  "item.minecraft.skull_banner_pattern.new": "Estampado de calavera",
  "item.minecraft.skull_pottery_shard": "Fragmento de cerámica de calavera",
  "item.minecraft.skull_pottery_sherd": "Fragmento de cerámica de calavera",
  "item.minecraft.slime_ball": "Bola de slime",
  "item.minecraft.slime_spawn_egg": "Generar slime",
  "item.minecraft.smithing_template": "Molde de herrería",
  "item.minecraft.smithing_template.applies_to": "Se aplica a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Coloca un lingote o cristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armadura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Coloca una parte de armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingotes y cristales",
  "item.minecraft.smithing_template.ingredients": "Ingredientes:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Coloca un lingote de netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Equipamiento de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Coloca una armadura, arma o herramienta de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingote de netherita",
  "item.minecraft.smithing_template.upgrade": "Mejora: ",
  "item.minecraft.sniffer_spawn_egg": "Generar sniffer",
  "item.minecraft.snort_pottery_shard": "Fragmento de cerámica de bufador",
  "item.minecraft.snort_pottery_sherd": "Fragmento de cerámica de bufador",
  "item.minecraft.snout_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Diseño de armadura de hocico",
  "item.minecraft.snow_golem_spawn_egg": "Generar gólem de nieve",
  "item.minecraft.snowball": "Bola de nieve",
  "item.minecraft.spectral_arrow": "Flecha espectral",
  "item.minecraft.spider_eye": "Ojo de araña",
  "item.minecraft.spider_spawn_egg": "Generar araña",
  "item.minecraft.spire_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Diseño de armadura de agujas",
  "item.minecraft.splash_potion": "Poción arrojadiza",
  "item.minecraft.splash_potion.effect.awkward": "Poción extraña arrojadiza",
  "item.minecraft.splash_potion.effect.empty": "Poción arrojadiza no fabricable",
  "item.minecraft.splash_potion.effect.fire_resistance": "Poción de resistencia al fuego arrojadiza",
  "item.minecraft.splash_potion.effect.harming": "Poción de daño arrojadiza",
  "item.minecraft.splash_potion.effect.healing": "Poción de curación arrojadiza",
  "item.minecraft.splash_potion.effect.infested": "Poción de infestación arrojadiza",
  "item.minecraft.splash_potion.effect.invisibility": "Poción de invisibilidad arrojadiza",
  "item.minecraft.splash_potion.effect.leaping": "Poción de salto arrojadiza",
  "item.minecraft.splash_potion.effect.levitation": "Poción de levitación arrojadiza",
  "item.minecraft.splash_potion.effect.luck": "Poción de la suerte arrojadiza",
  "item.minecraft.splash_potion.effect.mundane": "Poción mundana arrojadiza",
  "item.minecraft.splash_potion.effect.night_vision": "Poción de visión nocturna arrojadiza",
  "item.minecraft.splash_potion.effect.oozing": "Poción de mucosidad arrojadiza",
  "item.minecraft.splash_potion.effect.poison": "Poción de veneno arrojadiza",
  "item.minecraft.splash_potion.effect.regeneration": "Poción de regeneración arrojadiza",
  "item.minecraft.splash_potion.effect.slow_falling": "Poción de caída lenta arrojadiza",
  "item.minecraft.splash_potion.effect.slowness": "Poción de lentitud arrojadiza",
  "item.minecraft.splash_potion.effect.strength": "Poción de fuerza arrojadiza",
  "item.minecraft.splash_potion.effect.swiftness": "Poción de velocidad arrojadiza",
  "item.minecraft.splash_potion.effect.thick": "Poción espesa arrojadiza",
  "item.minecraft.splash_potion.effect.turtle_master": "Poción del maestro tortuga arrojadiza",
  "item.minecraft.splash_potion.effect.water": "Botella de agua arrojadiza",
  "item.minecraft.splash_potion.effect.water_breathing": "Poción de respiración acuática arrojadiza",
  "item.minecraft.splash_potion.effect.weakness": "Poción de debilidad arrojadiza",
  "item.minecraft.splash_potion.effect.weaving": "Poción de tejedura arrojadiza",
  "item.minecraft.splash_potion.effect.wind_charged": "Poción de cierzo arrojadiza",
  "item.minecraft.spruce_boat": "Bote de pino",
  "item.minecraft.spruce_chest_boat": "Bote de pino con cofre",
  "item.minecraft.spyglass": "Catalejo",
  "item.minecraft.squid_spawn_egg": "Generar calamar",
  "item.minecraft.stick": "Palo",
  "item.minecraft.stone_axe": "Hacha de piedra",
  "item.minecraft.stone_hoe": "Azada de piedra",
  "item.minecraft.stone_pickaxe": "Pico de piedra",
  "item.minecraft.stone_shovel": "Pala de piedra",
  "item.minecraft.stone_spear": "Lanza de piedra",
  "item.minecraft.stone_sword": "Espada de piedra",
  "item.minecraft.stray_spawn_egg": "Generar esqueleto glacial",
  "item.minecraft.strider_spawn_egg": "Generar strider",
  "item.minecraft.string": "Hilo",
  "item.minecraft.sugar": "Azúcar",
  "item.minecraft.suspicious_stew": "Estofado sospechoso",
  "item.minecraft.sweet_berries": "Frutos dulces",
  "item.minecraft.tadpole_bucket": "Cubeta con renacuajo",
  "item.minecraft.tadpole_spawn_egg": "Generar renacuajo",
  "item.minecraft.tide_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Diseño de armadura de la marea",
  "item.minecraft.tipped_arrow": "Flecha con efecto",
  "item.minecraft.tipped_arrow.effect.awkward": "Flecha con efecto",
  "item.minecraft.tipped_arrow.effect.empty": "Flecha con efecto no fabricable",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Flecha de resistencia al fuego",
  "item.minecraft.tipped_arrow.effect.harming": "Flecha de daño",
  "item.minecraft.tipped_arrow.effect.healing": "Flecha de curación",
  "item.minecraft.tipped_arrow.effect.infested": "Flecha de infestación",
  "item.minecraft.tipped_arrow.effect.invisibility": "Flecha de invisibilidad",
  "item.minecraft.tipped_arrow.effect.leaping": "Flecha de salto",
  "item.minecraft.tipped_arrow.effect.levitation": "Flecha de levitación",
  "item.minecraft.tipped_arrow.effect.luck": "Flecha de la suerte",
  "item.minecraft.tipped_arrow.effect.mundane": "Flecha con efecto",
  "item.minecraft.tipped_arrow.effect.night_vision": "Flecha de visión nocturna",
  "item.minecraft.tipped_arrow.effect.oozing": "Flecha de mucosidad",
  "item.minecraft.tipped_arrow.effect.poison": "Flecha venenosa",
  "item.minecraft.tipped_arrow.effect.regeneration": "Flecha de regeneración",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Flecha de caída lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Flecha de lentitud",
  "item.minecraft.tipped_arrow.effect.strength": "Flecha de fuerza",
  "item.minecraft.tipped_arrow.effect.swiftness": "Flecha de velocidad",
  "item.minecraft.tipped_arrow.effect.thick": "Flecha con efecto",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Flecha del maestro tortuga",
  "item.minecraft.tipped_arrow.effect.water": "Flecha salpicante",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Flecha de respiración acuática",
  "item.minecraft.tipped_arrow.effect.weakness": "Flecha de debilidad",
  "item.minecraft.tipped_arrow.effect.weaving": "Flecha de tejedura",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Flecha de ráfaga",
  "item.minecraft.tnt_minecart": "Vagón con dinamita",
  "item.minecraft.torchflower_seeds": "Semillas de anflorcha",
  "item.minecraft.totem_of_undying": "Tótem de la inmortalidad",
  "item.minecraft.trader_llama_spawn_egg": "Generar llama de comerciante",
  "item.minecraft.trial_key": "Llave de desafío",
  "item.minecraft.trident": "Tridente",
  "item.minecraft.tropical_fish": "Pez tropical",
  "item.minecraft.tropical_fish_bucket": "Cubeta con pez tropical",
  "item.minecraft.tropical_fish_spawn_egg": "Generar pez tropical",
  "item.minecraft.turtle_helmet": "Caparazón de tortuga",
  "item.minecraft.turtle_scute": "Escama de tortuga",
  "item.minecraft.turtle_spawn_egg": "Generar tortuga",
  "item.minecraft.vex_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Diseño de armadura de vex",
  "item.minecraft.vex_spawn_egg": "Generar vex",
  "item.minecraft.villager_spawn_egg": "Generar aldeano",
  "item.minecraft.vindicator_spawn_egg": "Generar vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "Generar comerciante nómada",
  "item.minecraft.ward_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Diseño de armadura de warden",
  "item.minecraft.warden_spawn_egg": "Generar warden",
  "item.minecraft.warped_fungus_on_a_stick": "Caña con champiñón distorsionado",
  "item.minecraft.water_bucket": "Cubeta de agua",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Diseño de armadura de buscacaminos",
  "item.minecraft.wheat": "Trigo",
  "item.minecraft.wheat_seeds": "Semillas de trigo",
  "item.minecraft.white_bundle": "Saco blanco",
  "item.minecraft.white_dye": "Tinte blanco",
  "item.minecraft.white_harness": "Arnés blanco",
  "item.minecraft.wild_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Diseño de armadura salvaje",
  "item.minecraft.wind_charge": "Carga de viento",
  "item.minecraft.witch_spawn_egg": "Generar bruja",
  "item.minecraft.wither_skeleton_spawn_egg": "Generar esqueleto del Wither",
  "item.minecraft.wither_spawn_egg": "Generar Wither",
  "item.minecraft.wolf_armor": "Armadura para lobo",
  "item.minecraft.wolf_spawn_egg": "Generar lobo",
  "item.minecraft.wooden_axe": "Hacha de madera",
  "item.minecraft.wooden_hoe": "Azada de madera",
  "item.minecraft.wooden_pickaxe": "Pico de madera",
  "item.minecraft.wooden_shovel": "Pala de madera",
  "item.minecraft.wooden_spear": "Lanza de madera",
  "item.minecraft.wooden_sword": "Espada de madera",
  "item.minecraft.writable_book": "Libro y pluma",
  "item.minecraft.written_book": "Libro escrito",
  "item.minecraft.yellow_bundle": "Saco amarillo",
  "item.minecraft.yellow_dye": "Tinte amarillo",
  "item.minecraft.yellow_harness": "Arnés amarillo",
  "item.minecraft.zoglin_spawn_egg": "Generar zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Generar caballo zombificado",
  "item.minecraft.zombie_nautilus_spawn_egg": "Generar nautilo zombi",
  "item.minecraft.zombie_spawn_egg": "Generar zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Generar aldeano zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Generar piglin zombificado"
}
export const es_ec = items; 
